(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
  function initProjectGallery(root) {
    if (!root || root.dataset.kpReady === 'true') return;
    const source = root.querySelector('[data-kp-gallery-data]');
    const dialog = root.querySelector('[data-kp-dialog]');
    const dialogImage = root.querySelector('[data-kp-dialog-image]');
    const dialogTitle = root.querySelector('[data-kp-dialog-title]');
    const dialogEvent = root.querySelector('[data-kp-dialog-event]');
    const productLink = root.querySelector('[data-kp-product-link]');
    const thumbs = root.querySelector('[data-kp-thumbs]');
    const status = root.querySelector('[data-kp-status]');
    if (!source || !dialog || !dialogImage || !dialogTitle || !dialogEvent || !productLink || !thumbs || !status) return;

    const data = JSON.parse(source.textContent);
    const cards = Array.from(root.querySelectorAll('[data-kp-card]'));
    const filters = Array.from(root.querySelectorAll('[data-kp-filter]'));
    let activeGroup = null;
    let activeImage = 0;
    let opener = null;

    function showImage(index) {
      if (!activeGroup || !activeGroup.images.length) return;
      activeImage = (index + activeGroup.images.length) % activeGroup.images.length;
      const image = activeGroup.images[activeImage];
      dialogImage.src = image.src;
      dialogImage.alt = image.alt;
      Array.from(thumbs.querySelectorAll('button')).forEach(function (button, buttonIndex) {
        button.setAttribute('aria-pressed', String(buttonIndex === activeImage));
      });
    }

    function renderThumbs() {
      thumbs.replaceChildren();
      activeGroup.images.forEach(function (image, index) {
        const button = document.createElement('button');
        const img = document.createElement('img');
        button.type = 'button';
        button.className = 'kp-project-dialog__thumb';
        button.setAttribute('aria-label', 'Show photo ' + (index + 1) + ' of ' + activeGroup.images.length);
        button.setAttribute('aria-pressed', String(index === activeImage));
        img.src = image.src;
        img.alt = '';
        button.appendChild(img);
        button.addEventListener('click', function () {
          showImage(index);
        });
        thumbs.appendChild(button);
      });
      thumbs.hidden = activeGroup.images.length < 2;
    }

    function openGroup(index, trigger) {
      activeGroup = data.groups[index];
      if (!activeGroup || typeof dialog.showModal !== 'function') return;
      activeImage = 0;
      opener = trigger;
      dialogTitle.textContent = activeGroup.design;
      dialogEvent.textContent = activeGroup.event;
      productLink.href = activeGroup.productUrl;
      renderThumbs();
      showImage(0);
      dialog.showModal();
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        const value = button.dataset.kpFilter;
        let visible = 0;
        filters.forEach(function (filterButton) {
          const selected = filterButton === button;
          filterButton.classList.toggle('is-active', selected);
          filterButton.setAttribute('aria-pressed', String(selected));
        });
        cards.forEach(function (card) {
          const show = value === 'all' || card.dataset.event === value;
          card.hidden = !show;
          if (show) visible += 1;
        });
        status.textContent = value === 'all'
          ? 'Showing all ' + visible + ' projects'
          : 'Showing ' + visible + ' ' + button.textContent.trim() + ' projects';
      });
    });

    root.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-kp-open]');
      if (!trigger || !root.contains(trigger)) return;
      openGroup(Number(trigger.dataset.groupIndex), trigger);
    });

    root.querySelector('[data-kp-close]').addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', function (event) {
      if (!activeGroup || activeGroup.images.length < 2) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showImage(activeImage - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(activeImage + 1);
      }
    });

    dialog.addEventListener('close', function () {
      dialogImage.removeAttribute('src');
      thumbs.replaceChildren();
      if (opener && typeof opener.focus === 'function') opener.focus();
      opener = null;
    });

    root.dataset.kpReady = 'true';
  }

  document.querySelectorAll('[data-kp-project-gallery]').forEach(initProjectGallery);
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-kp-project-gallery]');
    if (root) initProjectGallery(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-apparel-hub"] && !Shopify.designMode) return;
  try {
    
(async () => {
 const root = document.querySelector('[data-kp-apparel]');
 if (!root) return;
 if(root.dataset.kpApparelInitialized==='true')return;
 root.dataset.kpApparelInitialized='true';
 const {restoreCartJob,createSession}=await import(root.dataset.kpUxModuleUrl);
 const catalog = JSON.parse(root.querySelector('[data-kp-catalog]').textContent);
 const discontinued88181Size = catalog.find(item => item.id === '88181');
 if (discontinued88181Size) discontinued88181Size.sizes = discontinued88181Size.sizes.filter(size => size !== '6XL');
 const approvedS05610=catalog.find(item=>item.id==='S05610');
 if(approvedS05610)approvedS05610.sizes=approvedS05610.sizes.filter(size=>size!=='4XL');
function resolveApparelRoute(catalog, router, productId, search) {
 const eligible=catalog.filter(item=>item.id!=='ATCF2500');
 const nativeModel=router[String(productId||'')];
 const requested=new URLSearchParams(search).get('model');
 const modelId=nativeModel||requested;
 return eligible.some(item=>item.id===modelId)?modelId:null;
}

function loadApparelRouteDraft(storage,baseKey,routeModelId,now,lifetime) {
 const key=routeModelId?baseKey+'-model-'+routeModelId:baseKey;
 const valid=value=>value?.version===2 && Number.isFinite(value.savedAt) && now-value.savedAt>=0 && now-value.savedAt<lifetime;
 const matches=value=>!routeModelId||value?.modelId===routeModelId;
 let draft=null,legacy=false;
 try {
   const current=JSON.parse(storage.getItem(key)||'null');
   if(valid(current)&&matches(current))draft=current;
   if(!draft&&routeModelId){const old=JSON.parse(storage.getItem(baseKey)||'null');if(valid(old)&&matches(old)){draft=old;legacy=true;}}
 } catch (_) {}
 return {key,draft,legacy};
}

function buildApparelCartPlan(input, manifest, pricing) {
 const purchaseModel = manifest.models?.[input.modelId];
 if (!manifest.enabled || !purchaseModel || (manifest.enabledModels && !manifest.enabledModels.includes(input.modelId))) throw new Error('This style currently needs an inquiry.');
 const estimate = input.estimate;
 if (!estimate || estimate.currency !== manifest.planningCurrency || !['estimate','review-required'].includes(estimate.status)) throw new Error('Choose valid sizes and quantities first.');
 const routineHolds=['quantity-review','fit-review','planning-area-review'];
 if(input.modelId==='S05610'&&manifest.enabledModels?.includes('S05610'))routineHolds.push('availability-review','specification-review');
 if('|2400|5000|6506|7006|8800|8869|18000|18500|88181|WERK250|SF000|IND4000Z|L00550|18000B|18500B|VC700|Q126300|QTB|QTBG|5000B|'.includes(`|${input.modelId}|`)&&manifest.enabledModels?.includes(input.modelId))routineHolds.push('availability-review');
 if(purchaseModel.productKind==='hat' && purchaseModel.ownerProductionConfirmed)routineHolds.push('cap-size-review');
 if (estimate.holds?.some(x => !routineHolds.includes(x))) throw new Error('This selection needs a reviewed quote before checkout.');
 if(purchaseModel.excludedColors?.includes(input.color) || estimate.sides.some(side=>side.side==='back' && purchaseModel.backUnavailableColors?.includes(input.color)))throw new Error('This color or garment view needs an inquiry.');
 const sizes = input.sizes.filter(x => x.quantity > 0);
 const quantity = sizes.reduce((n,x) => n+x.quantity,0);
 if (!sizes.length || sizes.some(x => !Number.isSafeInteger(x.quantity) || x.quantity < 1) || quantity !== estimate.quantity || quantity > 100) throw new Error('Choose valid quantities up to 100 garments.');
 const quantityTier=apparelQuantityTier(quantity,manifest.quantityBreaks);
 if(estimate.tier!==quantityTier || new Set(sizes.map(item=>item.size)).size!==sizes.length) throw new Error('Review the approved quantity break and size mix.');
 const pricingModel=pricing?.models?.[input.modelId];
 const tierPrintFees=pricing?.printFees?.[pricingModel?.printClass];
 if(!pricingModel || !Array.isArray(tierPrintFees) || tierPrintFees.length!==manifest.quantityBreaks.length || !manifest.quantityBreaks.every((tier,index)=>tier===pricing.tiers?.[index]) || !tierPrintFees.every(value=>Number.isFinite(value)&&value>0)) throw new Error('This model needs a reviewed print-pricing configuration.');
 const sides = {front:false,back:false};
 const files = [];
 const properties = {Color:input.color,'Artwork approval':'Final dimensions, placement and color match require approval.','_kp_apparel_model':input.modelId,'_kp_apparel_pricing_version':manifest.version};
 if (input.notes?.trim()) properties['Order notes']=input.notes.trim();
 for (const side of estimate.sides) {
   const art = input.artwork[side.side];
   const pref = input.sidePrefs[side.side];
   if (!art?.file || !['png','jpeg','pdf'].includes(art.kind) || art.legacyUnsupported) throw new Error('Reselect each original PNG, JPEG or PDF before adding to cart.');
   const limits=purchaseModel.sideLimits[side.side];
   if (!limits || !['front','back'].includes(side.side) || !Number.isFinite(side.width) || !Number.isFinite(side.height) || side.width <= 0 || side.height <= 0 || side.width > limits.maxPrintWidthIn || side.height > limits.maxPrintHeightIn) throw new Error('This artwork exceeds the selected garment area.');
   sides[side.side]=true;
   const label = side.side === 'front' ? 'Front' : 'Back';
   properties[label+' print (in)']=side.width+' × '+side.height;
   properties[label+' artwork filename']=art.name;
   if(art.kind==='pdf')properties[label+' PDF page']=`${art.pdfPage} of ${art.pdfPages}`;
   if (pref.pantone?.trim()) properties[label+' Pantone Solid Coated']=pref.pantone.trim();
   if(art.alphaBounds) properties[label+' visible PNG bounds']=JSON.stringify({ ...art.alphaBounds,originalWidth:art.originalWidth,originalHeight:art.originalHeight });
   if(art.resolution) properties[label+' size basis']=art.resolution.label;
   properties[label+' preview placement']=Math.round(art.x)+'% across; '+Math.round(art.y)+'% down; '+Math.round(art.scale)+'% preview scale';
   files.push({property:label+' artwork',name:art.name,file:art.file,kind:art.kind,pdfPage:art.pdfPage,pdfPages:art.pdfPages});
 }
 const configuration=!estimate.sides.length ? 'Blank' : sides.front && sides.back ? 'Front + back' : sides.front ? 'Front only' : 'Back only';
 properties['_kp_apparel_configuration']=configuration;
 const lines=sizes.map(x=>{const id=purchaseModel.variants[x.size+'|'+configuration];if(!id)throw new Error('This size and print configuration needs a quote.');const rate=estimate.sizeLines.find(p=>p.size===x.size);if(!rate)throw new Error('This size needs an approved price.');const selectedPrinting=estimate.sides.length?rate.printing:0,tierIndex=manifest.quantityBreaks.indexOf(quantityTier),tierRatio=estimate.sides.length&&tierPrintFees?.[0]>0?tierPrintFees[tierIndex]/tierPrintFees[0]:1,basePrinting=estimate.sides.length?(Number.isFinite(rate.basePrinting)?rate.basePrinting:selectedPrinting/tierRatio):0;if(!Number.isFinite(rate.garment)||!Number.isFinite(selectedPrinting)||!Number.isFinite(basePrinting)||basePrinting<0)throw new Error('This size needs an approved price.');return{id,quantity:x.quantity,size:x.size,garment:rate.garment,basePrinting,selectedPrinting,perItem:rate.perItem};});
 return {lines,files,properties,quantity,modelId:input.modelId,productId:purchaseModel.productId,apparelProductIds:Object.values(manifest.models || {}).map(model=>model.productId),handle:purchaseModel.handle,discountTitle:purchaseModel.discountTitle,quantityTier,quantityBreaks:manifest.quantityBreaks,tierPrintFees,printSideCount:estimate.sides.length,selectedPrinting:estimate.printing,planningCurrency:manifest.planningCurrency,presentmentCurrencies:manifest.presentmentCurrencies,perItem:estimate.perItem,total:estimate.total};
}

function apparelProductIsSellable(product, model, lines) {
 if (!product || product.id !== model.productId || product.available !== true || typeof product.published_at !== 'string' || !product.published_at || !Array.isArray(product.variants)) return false;
 const selectedIds = lines ? lines.map(line => line.id) : Object.values(model.variants);
 const mapped = Object.entries(model.variants);
 if (new Set(mapped.map(([,id]) => id)).size !== mapped.length) return false;
 const available = id => {
   const mapping = mapped.find(([,variantId]) => variantId === id);
   const matches = product.variants.filter(variant => variant.id === id);
   return Boolean(mapping && matches.length === 1 && matches[0].title === mapping[0].replace('|', ' / ') && matches[0].available === true && Number.isSafeInteger(matches[0].price) && matches[0].price > 0);
 };
 return lines ? selectedIds.length > 0 && selectedIds.every(available) : selectedIds.some(available);
}

function apparelQuantityTier(quantity, breaks) {
 return breaks.reduce((tier, value) => quantity >= value ? value : tier, breaks[0]);
}

function repriceApparelCartPlan(plan, combinedQuantity) {
 if(!Number.isSafeInteger(combinedQuantity) || combinedQuantity<1 || combinedQuantity>100) throw new Error('Choose no more than 100 garments per apparel model.');
 const quantityTier=apparelQuantityTier(combinedQuantity,plan.quantityBreaks);
 if(plan.printSideCount===0)return {...plan,quantityTier};
 const tierIndex=plan.quantityBreaks.indexOf(quantityTier);
 const perSide=plan.tierPrintFees?.[tierIndex];
 const basePerSide=plan.tierPrintFees?.[0];
 if(!Number.isFinite(perSide)||perSide<=0||!Number.isFinite(basePerSide)||basePerSide<=0||!Number.isSafeInteger(plan.printSideCount)||plan.printSideCount<1)throw new Error('This model needs a reviewed print-pricing configuration.');
 const money=value=>Math.round((value+Number.EPSILON)*100)/100;
 const discountRatio=perSide/basePerSide;
 const lines=plan.lines.map(line=>{const garment=line.garment,basePrinting=line.basePrinting;if(!Number.isFinite(garment)||garment<0||!Number.isFinite(basePrinting)||basePrinting<=0)throw new Error('The fixed garment or printing price could not be confirmed.');const selectedPrinting=money(basePrinting*discountRatio);return {...line,selectedPrinting,perItem:money(garment+selectedPrinting)};});
 const total=money(lines.reduce((sum,line)=>sum+line.perItem*line.quantity,0));
 const perItem=lines.every(line=>line.perItem===lines[0].perItem)?lines[0].perItem:null;
 const selectedPrinting=lines.every(line=>line.selectedPrinting===lines[0].selectedPrinting)?lines[0].selectedPrinting:null;
 return {...plan,lines,quantityTier,selectedPrinting,perItem,total};
}

function validateApparelPresentmentCart(plan, context, cart, job, durable) {
 const minor = value => Number.isSafeInteger(value) && value >= 0;
 if (cart.currency !== context.currency || !plan.presentmentCurrencies.includes(cart.currency)) throw new Error('Your currency changed while adding apparel. Please review your selection again.');
 const lines = cart.items.filter(line => line.properties?._kp_apparel_job === job);
 if (lines.length !== plan.lines.length || new Set(lines.map(line => line.variant_id)).size !== plan.lines.length) throw new Error('Shopify could not confirm every selected size.');
 let selectedTotal = 0;
 for (const line of lines) {
   const planned = plan.lines.find(item => item.id === line.variant_id);
   const variant = context.variants.find(item => item.id === line.variant_id);
   if (!planned || !variant || line.product_id !== plan.productId || line.quantity !== planned.quantity) throw new Error('Shopify could not confirm this complete selection.');
   if (![line.original_price,line.original_line_price,line.final_price,line.final_line_price].every(minor) || line.original_price !== variant.price || line.original_line_price !== variant.price * line.quantity || line.final_line_price <= 0 || line.final_line_price > line.original_line_price) throw new Error('Shopify could not confirm the contextual garment price.');
   const roundedUnit = line.final_line_price / line.quantity;
   if (line.final_price !== Math.floor(roundedUnit) && line.final_price !== Math.ceil(roundedUnit)) throw new Error('Shopify returned inconsistent rounded prices.');
   const allocations = line.line_level_discount_allocations || [];
   if (!Array.isArray(allocations) || allocations.some(allocation => !minor(allocation.amount) || allocation.amount <= 0 || allocation.discount_application?.title !== plan.discountTitle)) throw new Error('An unexpected apparel discount needs review.');
   const discount = allocations.reduce((sum, allocation) => sum + allocation.amount, 0);
   if (line.original_line_price - line.final_line_price !== discount) throw new Error('Shopify could not confirm the applied printing discount.');
   if (plan.printSideCount > 0 && plan.quantityTier > 1 ? !allocations.length : allocations.length > 0) throw new Error('The approved apparel quantity discount was not confirmed for this selection.');
   if (cart.currency === plan.planningCurrency && line.final_line_price !== Math.round((planned.perItem + Number.EPSILON) * 100) * planned.quantity) throw new Error('The cart price differs from the approved planning price. Please contact us.');
   if (Object.entries(durable).some(([key,value]) => line.properties?.[key] !== value)) throw new Error('Artwork or print details did not persist on every size line.');
   selectedTotal += line.final_line_price;
 }
 if (cart.cart_level_discount_applications?.length) throw new Error('An additional cart discount needs review.');
 if (!minor(selectedTotal) || !minor(cart.total_price) || !cart.items.every(line => minor(line.final_line_price)) || cart.total_price !== cart.items.reduce((sum,line) => sum + line.final_line_price, 0) || cart.total_price < selectedTotal) throw new Error('Shopify could not confirm the actual cart total.');
 return {currency:cart.currency,selectedTotalMinor:selectedTotal,cartTotalMinor:cart.total_price,lines};
}

async function addApparelCartPlan(plan, options={}) {
 const request=options.fetch || fetch;
 const Form=options.FormData || FormData;
 const origin=options.origin || window.location.origin;
 const root=options.root || window.Shopify?.routes?.root || '/';
 const job=options.job || crypto.randomUUID();
 const replaceJob=typeof options.replaceJob==='string'&&/^[0-9a-f-]{36}$/i.test(options.replaceJob)?options.replaceJob:'';
 const properties={...plan.properties,'_kp_apparel_job':job};
 const call=async(endpoint,body)=>{const response=await request(root+endpoint,body?{method:'POST',...(body instanceof Form?{}:{headers:{'Content-Type':'application/json'}}),body:body instanceof Form?body:JSON.stringify(body)}:{});const data=await response.json();if(!response.ok)throw new Error(data.description || data.message || 'Shopify could not add this selection.');return data;};
 const permanentUrl=value=>{if(typeof value!=='string'||value.startsWith('blob:')||value.startsWith('data:'))return false;try{const u=new URL(value,origin);return u.protocol==='https:'&&(u.hostname===new URL(origin).hostname||u.hostname==='cdn.shopify.com')&&/\/(uploads|files)\//.test(u.pathname);}catch(_){return false;}};
 for(const art of plan.files){
   if(!art.file.size||art.file.size>10*1024*1024||!['png','jpeg','pdf'].includes(art.kind))throw new Error('Artwork must be a PNG, JPEG or PDF of 10 MB or less.');
   const bytes=new Uint8Array(await art.file.slice(0,8).arrayBuffer());
   const validPng=art.kind==='png'&&bytes.length===8&&[137,80,78,71,13,10,26,10].every((n,i)=>bytes[i]===n);
   const tail=art.kind==='jpeg'?new Uint8Array(await art.file.slice(-2).arrayBuffer()):null;
   const validJpeg=art.kind==='jpeg'&&bytes.length>=3&&bytes[0]===255&&bytes[1]===216&&bytes[2]===255&&tail?.length===2&&tail[0]===255&&tail[1]===217;
   const validPdf=art.kind==='pdf'&&bytes.length>=5&&bytes[0]===37&&bytes[1]===80&&bytes[2]===68&&bytes[3]===70&&bytes[4]===45&&Number.isSafeInteger(art.pdfPage)&&art.pdfPage>=1&&art.pdfPage<=art.pdfPages;
   if(!validPng&&!validJpeg&&!validPdf)throw new Error('Artwork file contents do not match the selected PNG, JPEG or PDF format.');
 }
 const existing=await call('cart.js');
 if(!plan.presentmentCurrencies.includes(existing.currency))throw new Error('This currency needs a reviewed apparel quote.');
 const replacing=replaceJob?existing.items.filter(line=>line.properties?._kp_apparel_job===replaceJob):[];
 if(replaceJob&&(!replacing.length||replacing.some(line=>line.product_id!==plan.productId||line.properties?._kp_apparel_model!==plan.modelId)))throw new Error('The apparel design selected for editing is no longer available in this cart.');
 const knownApparelIds=plan.apparelProductIds || [plan.productId];
 const existingApparel=existing.items.filter(line=>line.properties?._kp_apparel_job!==replaceJob&&(knownApparelIds.includes(line.product_id)||Boolean(line.properties?._kp_apparel_model)));
 const sameModelApparel=existingApparel.filter(line=>line.product_id===plan.productId);
 const existingQuantity=sameModelApparel.reduce((sum,line)=>sum+line.quantity,0);
 const combinedQuantity=plan.quantity+existingQuantity;
 const repricedPlan=repriceApparelCartPlan(plan,combinedQuantity);
 if(plan.printSideCount>0&&repricedPlan.quantityTier!==plan.quantityTier){
   const confirmTierChange=options.confirmTierChange || (details=>window.confirm('This model already has '+details.existingQuantity+' garments in your cart. Adding '+details.addedQuantity+' makes '+details.combinedQuantity+' and changes the print-only quantity tier from '+details.previousTier+'+ to '+details.combinedTier+'+. Garment prices by size stay fixed. Continue?'));
   const approved=await Promise.resolve(confirmTierChange({modelId:plan.modelId,existingQuantity,addedQuantity:plan.quantity,combinedQuantity,previousTier:plan.quantityTier,combinedTier:repricedPlan.quantityTier,previousPrinting:plan.selectedPrinting,combinedPrinting:repricedPlan.selectedPrinting}));
   if(!approved)throw new Error('Nothing was added. Review the combined quantity when you are ready.');
 }
 plan=repricedPlan;
 const product=await call('products/'+encodeURIComponent(plan.handle)+'.js');
 const purchaseModel = {productId:plan.productId,variants:Object.fromEntries(plan.lines.map(line => [line.size+'|'+plan.properties._kp_apparel_configuration,line.id]))};
 if(!apparelProductIsSellable(product,purchaseModel,plan.lines))throw new Error('Shopify could not confirm this published product and its selected sizes in your market.');
 const context={currency:existing.currency,variants:plan.lines.map(line=>{
   const variant=product.variants.find(item=>item.id===line.id);
   if(!variant || variant.available!==true || !Number.isSafeInteger(variant.price) || variant.price<=0)throw new Error('A selected size or print configuration is not available in your market.');
   const approvedBase = Math.round((line.perItem - plan.selectedPrinting + plan.tierPrintFees[0] * plan.printSideCount + Number.EPSILON) * 100);
   if(existing.currency === plan.planningCurrency && variant.price !== approvedBase)throw new Error('The garment or base printing price changed. Please contact us before ordering.');
   return {id:variant.id,price:variant.price};
 })};
 try {
   const form=new Form();
   form.set('id',String(plan.lines[0].id));form.set('quantity',String(plan.lines[0].quantity));
   for(const [key,value] of Object.entries(properties))form.set('properties['+key+']',value);
   for(const art of plan.files)form.set('properties['+art.property+']',art.file,art.name);
   const first=await call('cart/add.js',form);
   const item=first.items?.[0] || first;
   const durable={...properties};
   for(const art of plan.files){const url=item.properties?.[art.property];if(!permanentUrl(url))throw new Error('Shopify did not retain the uploaded artwork file. Please contact us.');durable[art.property]=url;}
   if(plan.lines.length>1)await call('cart/add.js',{items:plan.lines.slice(1).map(line=>({id:line.id,quantity:line.quantity,properties:durable}))});
   let cart=await call('cart.js');
   const transientQuantity=combinedQuantity+replacing.reduce((sum,line)=>sum+line.quantity,0);
   const transientTierQuantity=plan.modelId==='S05610'&&transientQuantity>100?1:Math.min(100,transientQuantity);
   const transientPlan=replacing.length?repriceApparelCartPlan(plan,transientTierQuantity):plan;
   let presentment=validateApparelPresentmentCart(transientPlan,context,cart,job,durable);
   if(replacing.length){
     // Shopify can change line keys when the temporary combined quantity changes discounts.
     // Match the original job's contents, ignoring keys/prices, before using fresh exact keys.
     const freshReplacing=cart.items.filter(line=>line.properties?._kp_apparel_job===replaceJob);
     const replacementSignature=lines=>JSON.stringify(lines.map(line=>JSON.stringify([line.product_id,line.variant_id,line.quantity,Object.entries(line.properties||{}).sort(([a],[b])=>a.localeCompare(b))])).sort());
     if(replacementSignature(freshReplacing)!==replacementSignature(replacing)||freshReplacing.some(line=>typeof line.key!=='string'||!line.key||cart.items.filter(item=>item.key===line.key).length!==1))throw new Error('The saved apparel design changed while updating. Your original design was not removed; review the cart before retrying.');
     await call('cart/update.js',{updates:Object.fromEntries(freshReplacing.map(line=>[line.key,0]))});
     cart=await call('cart.js');
     if(cart.items.some(line=>line.properties?._kp_apparel_job===replaceJob))throw new Error('Shopify could not replace the previous apparel design.');
     presentment=validateApparelPresentmentCart(plan,context,cart,job,durable);
   }
   return {cart,job,lines:presentment.lines,properties:durable,presentment};
 } catch(error) {
   try {const cart=await call('cart.js');const own=cart.items.filter(line=>line.properties?._kp_apparel_job===job);if(own.length)await call('cart/update.js',{updates:Object.fromEntries(own.map(line=>[line.key,0]))});const cleaned=await call('cart.js');if(cleaned.items.some(line=>line.properties?._kp_apparel_job===job))throw new Error('Cleanup incomplete');error.message+=' No incomplete apparel selection was kept.';} catch(_){error.message+=' Check your cart before retrying; cleanup could not be confirmed.';}
   if(replacing.length){
     try {const cart=await call('cart.js');if(!cart.items.some(line=>line.properties?._kp_apparel_job===replaceJob)){await call('cart/add.js',{items:replacing.map(line=>({id:line.variant_id,quantity:line.quantity,properties:line.properties}))});const restored=await call('cart.js');if(!restored.items.some(line=>line.properties?._kp_apparel_job===replaceJob))throw new Error('Restore incomplete');error.message+=' The previous apparel design was restored.';}} catch(_){error.message+=' The previous apparel design could not be restored automatically; review the cart before continuing.';}
   }
   throw error;
 }
}


function findAlphaBounds(pixels,width,height,threshold=1){
 let left=width,top=height,right=-1,bottom=-1;
 for(let y=0;y<height;y++)for(let x=0;x<width;x++)if(pixels[(y*width+x)*4+3]>=threshold){left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y);}
 return right<left?null:{left,top,width:right-left+1,height:bottom-top+1,alphaThreshold:threshold};
}
function pngResolution(bytes){
 const fallback={ppi:300,source:'default-300-ppi',label:'Estimated at 300 PPI; confirm intended physical size.'};
 if(bytes.length<8)return fallback;
 const view=new DataView(bytes.buffer,bytes.byteOffset,bytes.byteLength);
 for(let at=8;at+12<=bytes.length;){
   const n=view.getUint32(at);if(n>bytes.length-at-12)return fallback;
   const type=String.fromCharCode(...bytes.slice(at+4,at+8));
   if(type==='pHYs'&&n===9){
     const x=view.getUint32(at+8),y=view.getUint32(at+12),unit=bytes[at+16],ppi=x*.0254;
     if(unit===1&&x>0&&y>0&&Math.abs(x-y)/Math.max(x,y)<.01&&ppi>=30&&ppi<=2400)return {ppi,source:'png-resolution-metadata',label:`PNG declares ${Math.round(ppi)} PPI; confirm intended physical size.`};
     return {...fallback,reason:'Missing or unreliable physical resolution metadata'};
   }
   if(type==='IEND')break;at+=n+12;
 }
 return fallback;
}
function fitArtworkDimensions(width,height,limit){
 if(!(Number.isFinite(width)&&Number.isFinite(height)&&width>0&&height>0))return null;
 const maximumWidth=limit?.maxPrintWidthIn||30,maximumHeight=limit?.maxPrintHeightIn||30;
 const factor=Math.min(1,maximumWidth/width,maximumHeight/height);
 const roundDown=n=>Math.floor((n+1e-9)*10000)/10000;
 return {width:roundDown(width*factor),height:roundDown(height*factor),adjusted:factor<1,maximumWidth,maximumHeight};
}
function validArtworkDimensions(width,height,limit){
 return Number.isFinite(width)&&Number.isFinite(height)&&width>0&&height>0&&width<=(limit?.maxPrintWidthIn||30)+1e-8&&height<=(limit?.maxPrintHeightIn||30)+1e-8;
}
async function analyzePngArtwork(file){
 const bytes=new Uint8Array(await file.arrayBuffer()),resolution=pngResolution(bytes);
 const sourceUrl=URL.createObjectURL(file);
 try{
   const image=new Image();
   await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=()=>reject(new Error('This PNG could not be opened.'));image.src=sourceUrl;});
   const originalWidth=image.naturalWidth,originalHeight=image.naturalHeight;
   if(!originalWidth||!originalHeight||originalWidth*originalHeight>40000000)throw new Error('Please use a PNG below 40 million pixels so this browser can inspect its transparency.');
   const canvas=document.createElement('canvas');canvas.width=originalWidth;canvas.height=originalHeight;
   const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(image,0,0);
   const bounds=findAlphaBounds(context.getImageData(0,0,originalWidth,originalHeight).data,originalWidth,originalHeight);
   if(!bounds)throw new Error('This PNG is fully transparent. Upload a PNG with visible artwork.');
   const trimmed=document.createElement('canvas');trimmed.width=bounds.width;trimmed.height=bounds.height;
   trimmed.getContext('2d').drawImage(image,bounds.left,bounds.top,bounds.width,bounds.height,0,0,bounds.width,bounds.height);
   const blob=await new Promise(resolve=>trimmed.toBlob(resolve,'image/png'));if(!blob)throw new Error('This PNG preview could not be prepared.');
   return {url:URL.createObjectURL(blob),ratio:bounds.width/bounds.height,pixelWidth:bounds.width,pixelHeight:bounds.height,originalWidth,originalHeight,alphaBounds:bounds,resolution};
 }finally{URL.revokeObjectURL(sourceUrl);}
}

async function analyzeJpegArtwork(file){
 const sourceUrl=URL.createObjectURL(file);
 try{
   const image=new Image();
   await new Promise((resolve,reject)=>{image.onload=resolve;image.onerror=()=>reject(new Error('This JPEG could not be opened.'));image.src=sourceUrl;});
   const originalWidth=image.naturalWidth,originalHeight=image.naturalHeight;
   if(!originalWidth||!originalHeight||originalWidth*originalHeight>40000000)throw new Error('Please use a JPEG below 40 million pixels so this browser can prepare its preview.');
   const canvas=document.createElement('canvas');canvas.width=originalWidth;canvas.height=originalHeight;
   canvas.getContext('2d').drawImage(image,0,0);
   const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/jpeg',0.92));
   if(!blob)throw new Error('This JPEG preview could not be prepared.');
   return {url:URL.createObjectURL(blob),ratio:originalWidth/originalHeight,pixelWidth:originalWidth,pixelHeight:originalHeight,originalWidth,originalHeight,alphaBounds:null,resolution:{ppi:300,source:'jpeg-planning-default',label:'JPEG preview uses a 300 PPI planning estimate; background retained'}};
 }finally{URL.revokeObjectURL(sourceUrl);}
}

let pdfArtworkModulePromise;
async function analyzePdfArtworkFile(file,pageNumber=1){
 if(!pdfArtworkModulePromise)pdfArtworkModulePromise=import(root.dataset.kpPdfHelperUrl);
 const module=await pdfArtworkModulePromise;
 return module.analyzePdfArtwork(file,{
   pageNumber,
   moduleUrl:root.dataset.kpPdfModuleUrl,
   workerUrl:root.dataset.kpPdfWorkerUrl
 });
}

 const retailPricing = JSON.parse(root.querySelector('[data-kp-retail-pricing]').textContent);
 retailPricing.models['5000B'].garmentBySize={XS:6.5,S:6.5,M:6.5,L:6.5,XL:6.5};
 let currentEstimate = null;
function apparelPrintLimit(model,side) { return {...model,...model?.sideLimits?.[side]}; }
function calculateApparelEstimate(data, modelId, sizes, prints, invalidInputs=false) {
 const model=data.models[modelId];
 const empty=(status,message)=>({status,message,currency:data.currency,version:data.version,holds:[]});
 if(!model)return empty('quote-only','This style needs a quote.');
 if(invalidInputs||!Array.isArray(sizes)||sizes.some(x=>!Number.isSafeInteger(x.quantity)||x.quantity<0))return empty('invalid','Enter valid whole-number quantities and print dimensions.');
 const selected=sizes.filter(x=>x.quantity>0);
 const quantity=selected.reduce((n,x)=>n+x.quantity,0);
 if(!quantity)return empty('missing-input','Choose quantities, add artwork and enter its print dimensions.');
 if(quantity>100)return empty('quote-only','More than 100 items: contact us for a quote.');
 if(selected.some(x=>!Object.hasOwn(model.garmentBySize,x.size)))return empty('quote-only','A selected garment size has no approved draft price. Contact us for a quote.');
 if(!model.printClass)return empty('quote-only','The print area and flat printing fee for this category are unconfirmed. Garment prices by size are shown for planning.');
 if(!prints.length){
   const money=n=>Math.round((n+Number.EPSILON)*100)/100;
   const sizeLines=selected.map(x=>{const garment=model.garmentBySize[x.size];return {size:x.size,quantity:x.quantity,garment,printing:0,perItem:garment,total:money(garment*x.quantity),sizeAdjustmentEstimated:!!model.sizeAdjustmentEstimated[x.size]};});
   const garmentTotal=money(sizeLines.reduce((n,x)=>n+x.garment*x.quantity,0));
   const tier=data.tiers.reduce((found,value)=>quantity>=value?value:found,data.tiers[0]);
   return {status:'estimate',message:'Blank garment price',currency:data.currency,version:data.version,quantity,tier,garmentTotal,printing:0,printingTotal:0,perItem:sizeLines.every(x=>x.perItem===sizeLines[0].perItem)?sizeLines[0].perItem:null,total:garmentTotal,sides:[],sizeLines,holds:[]};
 }
 if(prints.some(p=>!p.hasArtwork))return empty('missing-input','Upload valid PNG, JPEG or PDF artwork for every requested print.');
 if(prints.some(p=>!(Number.isFinite(p.width)&&Number.isFinite(p.height)&&p.width>0&&p.height>0)))return empty('missing-input','Enter both print dimensions. The artwork proportions remain linked.');
 if(prints.some(p=>!['front','back'].includes(p.side))||new Set(prints.map(p=>p.side)).size!==prints.length)return empty('invalid','Choose one artwork file per approved print side. No sleeve or other-area printing.');
 if(prints.some(p=>p.side==='back'&&!model.backAllowed))return empty('quote-only','Caps offer a front-panel inquiry only; back, side, bill and mesh printing are not approved.');
 const oversized=prints.find(p=>{const limit=apparelPrintLimit(model,p.side);return p.width>limit.maxPrintWidthIn||p.height>limit.maxPrintHeightIn;});
 if(oversized){const limit=apparelPrintLimit(model,oversized.side);return empty('quote-only',`Maximum ${oversized.side} planning size is ${limit.maxPrintWidthIn} × ${limit.maxPrintHeightIn} in. Actual product fit requires confirmation.`);}
 const tierIndex=data.tiers.reduce((found,tier,i)=>quantity>=tier?i:found,0);
 const tier=data.tiers[tierIndex],fee=data.printFees[model.printClass]?.[tierIndex];
 if(!(Number.isFinite(fee)&&fee>0))return empty('quote-only','This print fee needs confirmation.');
 const money=n=>Math.round((n+Number.EPSILON)*100)/100;
 const sides=prints.map(p=>({side:p.side,width:p.width,height:p.height,retail:fee}));
 const printing=money(fee*sides.length);
 const sizeLines=selected.map(x=>{const garment=model.garmentBySize[x.size],perItem=money(garment+printing);return {size:x.size,quantity:x.quantity,garment,printing,perItem,total:money(perItem*x.quantity),sizeAdjustmentEstimated:!!model.sizeAdjustmentEstimated[x.size]};});
 const garmentTotal=money(sizeLines.reduce((n,x)=>n+x.garment*x.quantity,0));
 const total=money(sizeLines.reduce((n,x)=>n+x.total,0));
 const uniform=sizeLines.every(x=>x.perItem===sizeLines[0].perItem);
 const holds=[];
 if(quantity!==tier)holds.push('quantity-review');
 if(model.fitReview)holds.push('fit-review');
 if(model.techniqueReview)holds.push('technique-review');
 if(model.specificationReview)holds.push('specification-review');
 if(model.availabilityReview)holds.push('availability-review');
 if(model.maxEnvelopeReview)holds.push('cap-size-review');
 if(model.planningAreaReview)holds.push('planning-area-review');
 return {status:holds.length?'review-required':'estimate',message:holds.length?'Draft price estimate · production approval required':'Draft price estimate',currency:data.currency,version:data.version,printFeeRevision:model.printClass==='Cap'?data.ownerPriceOverrides?.hatPrinting?.revision:(model.ownerPlanningFeeRevision||data.version),quantity,tier,garmentTotal,printing,printingTotal:money(printing*quantity),perItem:uniform?sizeLines[0].perItem:null,total,sides,sizeLines,holds};
}

function presentmentApparelEstimate(estimate) {
 const purchaseModel=pilotManifest.models?.[selected.id];
 const entry=cartSellability.get(cartSellabilityKey());
 if(!purchaseModel||entry?.status!=='ready'||!entry.product||!entry.currency||!estimate.sizeLines?.length)return null;
 const money=value=>Math.round((value+Number.EPSILON)*100)/100;
 const sideCount=estimate.sides?.length||0;
 const configuration=!sideCount?'Blank':sideCount===2?'Front + back':estimate.sides[0].side==='front'?'Front only':'Back only';
 const tierIndex=retailPricing.tiers.indexOf(estimate.tier);
 const planningFees=retailPricing.printFees[retailPricing.models[selected.id]?.printClass];
 const discountRatio=sideCount&&tierIndex>=0&&planningFees?.[0]>0?planningFees[tierIndex]/planningFees[0]:1;
 if(sideCount&&(!Number.isFinite(discountRatio)||discountRatio<=0||discountRatio>1))return null;
 const variantPrice=id=>{
   const variant=entry.product.variants.find(item=>item.id===id);
   return variant?.available===true&&Number.isSafeInteger(variant.price)&&variant.price>0?variant.price/100:null;
 };
 const sizeLines=[];
 for(const line of estimate.sizeLines){
   const blank=variantPrice(purchaseModel.variants[line.size+'|Blank']);
   if(!Number.isFinite(blank))return null;
   let printing=0,basePrinting=0;
   if(sideCount){
     const printed=variantPrice(purchaseModel.variants[line.size+'|'+configuration]);
     basePrinting=Number.isFinite(printed)?money(printed-blank):NaN;
     if(!Number.isFinite(basePrinting)||basePrinting<=0)return null;
     printing=money(basePrinting*discountRatio);
   }
   const perItem=money(blank+printing);
   sizeLines.push({...line,garment:blank,basePrinting,printing,perItem,total:money(perItem*line.quantity)});
 }
 const uniformPrinting=!sideCount||sizeLines.every(line=>line.printing===sizeLines[0].printing);
 const printing=!sideCount?0:uniformPrinting?sizeLines[0].printing:null;
 const garmentTotal=money(sizeLines.reduce((sum,line)=>sum+line.garment*line.quantity,0));
 const printingTotal=money(sizeLines.reduce((sum,line)=>sum+line.printing*line.quantity,0));
 const total=money(sizeLines.reduce((sum,line)=>sum+line.total,0));
 const sides=sideCount?estimate.sides.map(side=>({...side,retail:uniformPrinting?money(printing/sideCount):null})):[];
 return {...estimate,currency:entry.currency,garmentTotal,printing,printingTotal,total,sides,sizeLines,variablePrinting:sideCount&&!uniformPrinting,perItem:sizeLines.every(line=>line.perItem===sizeLines[0].perItem)?sizeLines[0].perItem:null,presentmentBasis:'Published Shopify market variants',presentmentTierDerived:tierIndex>0};
}

function apparelPriceDisplayIsVerified(estimate,marketEstimate,currency,enabled) {
 const productionHolds=['quantity-review','fit-review','specification-review','availability-review','planning-area-review','media-review'];
 return Boolean(enabled&&marketEstimate&&marketEstimate.currency===currency&&['CAD','USD'].includes(currency)&&['estimate','review-required'].includes(estimate.status)&&Number.isFinite(estimate.total)&&estimate.quantity>0&&estimate.quantity<=100&&estimate.sizeLines?.length&&estimate.sizeLines.every(line=>Number.isFinite(line.perItem)&&Number.isFinite(line.total))&&estimate.holds.every(hold=>productionHolds.includes(hold))&&!(currency==='USD'&&estimate.sides?.length&&estimate.presentmentTierDerived));
}

 const selectableCatalog = catalog.filter(item => item.id !== 'ATCF2500');
 const groups = ['Adult · T-shirts', 'Adult · Polos', 'Adult · Hoodies', 'Adult · Crewnecks', 'Hats · Caps', 'Bags · Totes', 'Kids · T-shirts', 'Kids · Crewnecks', 'Kids · Hoodies'];
 const categories = ['tshirts', 'polos', 'hoodies', 'crewnecks', 'hats', 'bags', 'kids'];
 const categoryFor = group => group.startsWith('Kids') ? 'kids' : group === 'Adult · Polos' ? 'polos' : group === 'Adult · Hoodies' ? 'hoodies' : group === 'Adult · Crewnecks' ? 'crewnecks' : group.startsWith('Hats') ? 'hats' : group.startsWith('Bags') ? 'bags' : 'tshirts';
 const areas = { front: 'Front', back: 'Back' };
 const cdn = (id, side = 'f') => `https://cdn.ssactivewear.com/Images/Color/${id}_${side}_fl.jpg`;
 const colorsFor = item => item.colors.split('|').map(part => { const [name, id] = part.split(':'); return { name, id: id || '' }; });
 const photoFor = (item, entry, side = 'front') => item.verifiedMedia ? ((side === 'back' ? item.backImages : item.images) || {})[entry.name] || '' : entry.id ? cdn(entry.id, side === 'back' ? 'b' : 'f') : ((side === 'back' ? item.backImages : item.images) || {})[entry.name] || '';
 // Measured visible garment heights in existing front product photos, relative to each source canvas.
 // CSS zoom centers the visible garment; the artwork layout uses the same zoom.
 const visibleHeight = { '5000': .82, 'WERK250': .938, 'HERO300': .74, '88181': .77,
   '18500': .876, 'IND4000Z': .909, '5000B': .714, '18000B': .696, '18500B': .807 };
 const previewZoom = item => item.verifiedMedia ? 1 : Math.max(.85, Math.min(1.22, .84 / (visibleHeight[item.id] || .84)));
 const supportedAreas = () => selected.views || ['front', 'back'];
 const $ = selector => root.querySelector(selector);
 const stage = $('[data-kp-image]');
 const pilotManifest = JSON.parse(root.querySelector('[data-kp-apparel-pilot]').textContent);
 pilotManifest.models.S05610={...pilotManifest.models['5000'],productId:15420217196697,handle:'kp-apparel-s05610-draft',variants:{"S|Front only":67682540519577,"S|Back only":67682540552345,"S|Front + back":67682540585113,"M|Front only":67682540617881,"M|Back only":67682540650649,"M|Front + back":67682540683417,"L|Front only":67682540716185,"L|Back only":67682540748953,"L|Front + back":67682540781721,"XL|Front only":67682540814489,"XL|Back only":67682540847257,"XL|Front + back":67682540880025,"2XL|Front only":67682540912793,"2XL|Back only":67682540945561,"2XL|Front + back":67682540978329,"3XL|Front only":67682541011097,"3XL|Back only":67682541043865,"3XL|Front + back":67682541076633},status:'ACTIVE'};
 pilotManifest.models.S05610.discountTitle='Kippush S05610 quantity pricing';
 const blankVariants={
   'S05610':{'S':67727945466009,'M':67727945498777,'L':67727945531545,'XL':67727945564313,'2XL':67727945597081,'3XL':67727945629849},
   '2400':{'S':67726601191577,'M':67726601224345,'L':67726601257113,'XL':67726601289881,'2XL':67726601322649,'3XL':67726601355417,'4XL':67726601388185,'5XL':67726601420953},
   '5000':{'S':67726602764441,'M':67726602797209,'L':67726602829977,'XL':67726602862745,'2XL':67726602895513,'3XL':67726602928281,'4XL':67726602961049,'5XL':67726602993817},
   '6506':{'Adjustable':67726587003033},
   '7006':{'S':67726600077465,'M':67726600110233,'L':67726600143001,'XL':67726600175769,'2XL':67726600208537,'3XL':67726600241305},
   '8800':{'S':67726637662361,'M':67726637695129,'L':67726637727897,'XL':67726637760665,'2XL':67726637793433,'3XL':67726637826201,'4XL':67726637858969,'5XL':67726637891737},
   '8869':{'Adjustable':67726590574745},
   '18000':{'XS':67726604501145,'S':67726604533913,'M':67726604566681,'L':67726604599449,'XL':67726604632217,'2XL':67726604664985,'3XL':67726604697753,'4XL':67726604730521,'5XL':67726604763289},
   '18500':{'XS':67726605746329,'S':67726605779097,'M':67726605811865,'L':67726605844633,'XL':67726605877401,'2XL':67726605910169,'3XL':67726605942937,'4XL':67726605975705,'5XL':67726606008473},
   '88181':{'XS':67726608269465,'S':67726608302233,'M':67726608335001,'L':67726608367769,'XL':67726608400537,'2XL':67726608433305,'3XL':67726608466073,'4XL':67726608498841,'5XL':67726608531609},
   'WERK250':{'XS':67726612889753,'S':67726612922521,'M':67726612955289,'L':67726612988057,'XL':67726613020825,'2XL':67726613053593,'3XL':67726613086361,'4XL':67726613119129,'5XL':67726613151897,'6XL':67726613184665},
   'SF000':{'S':67726613282969,'M':67726613315737,'L':67726613348505,'XL':67726613381273,'2XL':67726613414041,'3XL':67726613446809,'4XL':67726613479577},
   'IND4000Z':{'S':67726613741721,'M':67726613774489,'L':67726613807257,'XL':67726613840025,'2XL':67726613872793,'3XL':67726613905561},
   '5000B':{'XS':67726677016729,'S':67726677049497,'M':67726677082265,'L':67726677115033,'XL':67726677147801},
   'L00550':{'XS':67726615380121,'S':67726615412889,'M':67726615445657,'L':67726615478425,'XL':67726615511193,'2XL':67726615543961,'3XL':67726615576729,'4XL':67726615609497},
   '18000B':{'XS':67726615806105,'S':67726615838873,'M':67726615871641,'L':67726615904409,'XL':67726615937177},
   '18500B':{'XS':67726616035481,'S':67726616068249,'M':67726616101017,'L':67726616133785,'XL':67726616166553},
   'VC700':{'Adjustable':67726593949849},
   'Q126300':{'One Size':67726598865049},
   'QTB':{'One Size':67726585823385},
   'QTBG':{'One Size':67726577041561}
 };
 Object.entries(blankVariants).forEach(([modelId,sizes])=>{const model=pilotManifest.models[modelId];Object.entries(sizes).forEach(([size,id])=>{model.variants[size+'|Blank']=id;});model.status='ACTIVE';});
 pilotManifest.enabledModels=Object.keys(blankVariants);
 let baseDraftKey = 'kp-apparel-inquiry-v2';
 const nativeProductRouter=JSON.parse(root.querySelector('[data-kp-native-product-router]').textContent);nativeProductRouter['15420217196697']='S05610';
 const routeModelId=resolveApparelRoute(catalog,nativeProductRouter,root.dataset.kpNativeProductId,window.location.search);
 const editJobValue=new URLSearchParams(window.location.search).get('edit_job')||'';
 const editJob=/^[0-9a-f-]{36}$/i.test(editJobValue)?editJobValue:'';
 if(editJob)baseDraftKey+='-cart-'+editJob;
 let cartEditReady=!editJob,cartRestoreError='',restoredCartFiles={};
 let routeStorage;try{routeStorage=window.sessionStorage;}catch(_){}
 const routeDraft=loadApparelRouteDraft(routeStorage,baseDraftKey,routeModelId,Date.now(),24*60*60*1000);
 const draftKey=routeDraft.key;
 const draftLifetime = 24 * 60 * 60 * 1000;
 let savedDraft=routeDraft.draft;
 if(editJob){
  root.querySelector('[data-kp-draft-status]').textContent='Restoring the selected cart design…';
  root.querySelector('.kp-apparel__content').inert=true;
  try{const restored=await restoreCartJob(editJob,routeModelId,pilotManifest.models?.[routeModelId],location.origin,window.Shopify?.routes?.root||'/');savedDraft=restored.draft;restoredCartFiles=restored.files;
   if(!colorsFor(selectableCatalog.find(item=>item.id===routeModelId)).some(entry=>entry.name===savedDraft.color))throw Error('The saved garment colour is unavailable. Review your cart.');}
  catch(error){cartRestoreError=error.message;savedDraft=null;}
 }
 const savedModelAvailable = selectableCatalog.some(item => item.id === savedDraft?.modelId);
 const migratingSelection = Boolean(savedDraft?.modelId && !savedModelAvailable);
 let migrationNotice = savedDraft?.migrationNotice || '';
 if (savedDraft?.modelId && !savedModelAvailable) {
   const previous = catalog.find(item => item.id === savedDraft.modelId);
   const replacement = previous?.id === 'ATCF2500'
     ? selectableCatalog.find(item => item.id === '18500')
     : selectableCatalog[0];
   migrationNotice = `${previous?.name || savedDraft.model || 'Your previous style'} is no longer selectable in this apparel draft. ${replacement.name} is shown for review. Your notes, print details and matching size quantities have been kept. Saved artwork is restored when its local file is available; reselect the original if prompted. Please confirm the style, color and sizes before contacting us.`;
 }
 let selected = selectableCatalog.find(item => item.id === routeModelId)
   || selectableCatalog.find(item => item.id === savedDraft?.modelId)
   || (savedDraft?.modelId === 'ATCF2500' && selectableCatalog.find(item => item.id === '18500'))
   || selectableCatalog[0];
 let color = colorsFor(selected).find(entry => entry.name === savedDraft?.color) || colorsFor(selected)[0];
 let view = savedDraft?.view === 'back' ? 'back' : 'front';
 let activeCategory = categoryFor(selected.group);
 let colorExpanded = false;
 let imageRequest = 0;
 let fileRequest = 0;
 let renderedSizeModelId = null;
 const artwork = { front: null, back: null };
 const sidePrefs = Object.fromEntries(Object.keys(areas).map(area => [area, {
   width: savedDraft?.sidePrefs?.[area]?.width || '',
   height: savedDraft?.sidePrefs?.[area]?.height || '',
   pantone: savedDraft?.sidePrefs?.[area]?.pantone || ''
 }]));
 let restoring = Boolean(savedDraft);
 let storageWarning = '';
 let dbPromise;
 const artDb = () => {
   if (!('indexedDB' in window)) return Promise.reject(new Error('Local file storage is unavailable'));
   if (!dbPromise) dbPromise = new Promise((resolve, reject) => {
     const req = indexedDB.open('kp-apparel-local-v2', 1);
     req.onupgradeneeded = () => req.result.createObjectStore('files');
     req.onsuccess = () => resolve(req.result);
     req.onerror = () => reject(req.error);
   });
   return dbPromise;
 };
 async function fileStore(method, key, value) {
   const db = await artDb();
   return new Promise((resolve, reject) => {
     const tx = db.transaction('files', 'readwrite');
     const scopedKey=draftKey+':'+key;
     const req = tx.objectStore('files')[method](...(method === 'put' ? [value, scopedKey] : [scopedKey]));
     req.onsuccess = () => {
        if(method==='get' && !req.result && !editJob && (!routeModelId || routeDraft.legacy)){
          const fallback=db.transaction('files','readonly').objectStore('files').get(key);
         fallback.onsuccess=()=>resolve(fallback.result);fallback.onerror=()=>reject(fallback.error);
       }else resolve(req.result);
     };
     req.onerror = () => reject(req.error);
   });
 }
 function saveDraft() {
   if (restoring || (editJob&&!cartEditReady)) return true;
   const sizes = Object.fromEntries([...root.querySelectorAll('.kp-apparel__size input')].map(input => [input.dataset.size, input.value]));
   const snapshot = { version: 2, savedAt: Date.now(), modelId: selected.id, model: selected.name, color: color.name,
     view, sizes, estimate: currentEstimate, notes: $('#kp-apparel-notes').value, sidePrefs, migrationNotice,cartJob:activeCartJob,cartCommitted,
     artwork: Object.fromEntries(Object.keys(areas).map(area => [area, artwork[area] ? {
       name: artwork[area].name, kind: artwork[area].kind, alphaBounds: artwork[area].alphaBounds, originalWidth: artwork[area].originalWidth, originalHeight: artwork[area].originalHeight, resolution: artwork[area].resolution, pdfPage: artwork[area].pdfPage, pdfPages: artwork[area].pdfPages, maxFitAdjusted: artwork[area].maxFitAdjusted, x: artwork[area].x, y: artwork[area].y, scale: artwork[area].scale
     } : null])) };
   try { sessionStorage.setItem(draftKey, JSON.stringify(snapshot)); $('[data-kp-handoff-error]').hidden = true; return true; }
   catch (_) {
     const message = 'This browser could not save your selections. Keep this page open or copy your details before contacting us.';
     $('[data-kp-handoff-error]').textContent = message;
     $('[data-kp-handoff-error]').hidden = false;
     return false;
   }
 }
 function persistArtwork(area) {
   const art = artwork[area];
   if (!art?.file) return;
   fileStore('put', area, { file: art.file, savedAt: Date.now() }).catch(() => {
     storageWarning = 'The original artwork could not be saved locally. Keep this page open and email your file separately.';
     $('[data-kp-file-note]').textContent = storageWarning;
   });
 }
 function normalizeSelection() {
   selected = selectableCatalog.find(item => item.id === selected?.id) || selectableCatalog[0];
   if (!supportedAreas().includes(view)) view = 'front';
   const choices = colorsFor(selected);
   color = choices.find(entry => entry.name === color?.name) || choices[0];
 }
 const models = $('[data-kp-models]');
 const catalogPanel = $('[data-kp-catalog-panel]');
 const catalogToggle = $('[data-kp-catalog-toggle]');
 const closeCatalog = () => { catalogPanel.classList.remove('is-open'); catalogToggle.setAttribute('aria-expanded', 'false'); };
 catalogToggle.addEventListener('click', () => {
   const open = catalogPanel.classList.toggle('is-open');
   catalogToggle.setAttribute('aria-expanded', String(open));
 });
 const categoryTabs = [...root.querySelectorAll('[data-kp-category]')];
 function selectCategory(id, focus = false) {
   activeCategory = id;
   categoryTabs.forEach(tab => {
     const selectedTab = tab.dataset.kpCategory === id;
     tab.setAttribute('aria-selected', String(selectedTab));
     tab.tabIndex = selectedTab ? 0 : -1;
     if (selectedTab && focus) tab.focus();
   });
   models.querySelectorAll('[data-kp-category-group]').forEach(section => { section.hidden = section.dataset.kpCategoryGroup !== id; });
   $('[data-kp-models]').setAttribute('aria-labelledby', `kp-apparel-category-${id}`);
 }
 categoryTabs.forEach((tab, index) => {
   tab.addEventListener('click', () => selectCategory(tab.dataset.kpCategory));
   tab.addEventListener('keydown', event => {
     let next;
     if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % categories.length;
     else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + categories.length - 1) % categories.length;
     else if (event.key === 'Home') next = 0;
     else if (event.key === 'End') next = categories.length - 1;
     else return;
     event.preventDefault(); selectCategory(categories[next], true);
   });
 });
 groups.forEach(group => {
   const section = document.createElement('section');
   section.className = 'kp-apparel__group';
   section.dataset.kpCategoryGroup = categoryFor(group);
   section.id = group.toLowerCase().replace(/[^a-z]+/g, '-').replace(/-$/, '');
   const heading = document.createElement('h3'); heading.textContent = group; section.append(heading);
   const grid = document.createElement('div'); grid.className = 'kp-apparel__cards';
   selectableCatalog.filter(item => item.group === group).forEach(item => {
     const button = document.createElement('button'); button.type = 'button'; button.className = 'kp-apparel__card'; button.dataset.model = item.id;
     const first = colorsFor(item)[0]; const src = photoFor(item, first);
     const photo = src ? `<img src="${src}" alt="${item.name}, ${first.name}, garment only" loading="lazy" width="86" height="86">` : '<span class="kp-apparel__card-photo">Photo being verified</span>';
     button.innerHTML = `${photo}<span><strong>${item.name}</strong></span>`;
     button.addEventListener('click', async () => {
       if (selected.id === item.id) { closeCatalog(); return; }
       if(routeModelId){
         if(!saveDraft())return;
         const next=new URL(root.dataset.kpBuilderUrl,window.location.origin);next.searchParams.set('model',item.id);
         session.navigate(next.pathname+next.search);return;
       }
       const hasDraft = Object.values(artwork).some(Boolean) || Object.values(sidePrefs).some(p => p.width || p.height || p.pantone) || $('#kp-apparel-notes').value.trim() || [...root.querySelectorAll('.kp-apparel__size input')].some(input => input.value && input.value !== '0');
       if (hasDraft && !await session.confirmChange()) return;
       clearArtwork(); fileRequest++; view = 'front'; $('#kp-apparel-notes').value = ''; savedDraft = null;
       selected = item; color = colorsFor(item)[0]; colorExpanded = false; migrationNotice = '';session.changed();
       closeCatalog();
       render();
       if (window.innerWidth < 1050) $('#apparel-detail').scrollIntoView({ behavior: 'smooth', block: 'start' });
     });
     grid.append(button);
   });
   section.append(grid); models.append(section);
 });
 selectCategory(activeCategory);

 function clearArtwork(area, keepPreferences = false) {
   (area ? [area] : Object.keys(areas)).forEach(key => {
     if (artwork[key]?.url) URL.revokeObjectURL(artwork[key].url);
     artwork[key] = null;
     if (!keepPreferences) sidePrefs[key] = { width: '', height: '', pantone: '' };
     if (!keepPreferences) fileStore('delete', key).catch(() => {});
   });
   saveDraft();
 }
 const fallbackColors = {
   'Black':'#222326','Acid Black':'#3b3d3a','White':'#f9f9f7','Athletic Grey':'#a4a8ab','Athletic Heather':'#adb2b4','Dark Navy':'#202b45','Navy':'#23345c','Team Navy':'#1d2d50','Heather Navy':'#56647d',
   'Caramel':'#aa7957','Safety Yellow':'#f5e42d','Sand':'#d8c6aa','Safety Orange':'#ef792d','Icy Rock':'#abb9b9','Ivory':'#eee5d4','Dusty Green':'#899b8e',
   'Sapphire':'#276eac','Heather Royal':'#6686af','Royal':'#2858a5','Team Royal':'#315da7','Dark Heather Grey':'#595e66','Team Dark Heather':'#50545c','Light Blue':'#accbe3','Ash Grey':'#d2d4d2',
   'Purple':'#563c78','Team Purple':'#543675','Red':'#ae2d3e','Sangria':'#7b304f','Team Red':'#aa2937','Heather Red':'#a76971','Maroon':'#662f3d','Orange':'#e77836',
   'Kelly':'#2b965c','Military Green':'#667457','Dark Green':'#20563f','Team Forest Green':'#24503c','Oatmeal Heather':'#d7cab6','Dark Chocolate Brown':'#4d352e','Gold':'#dda636','Team Gold':'#d4a331','Safety Green':'#b7d73c'
 };
 function fabricFor(item, name) {
   if (item.id === '5000' || item.id === '5000B') {
     if (name === 'Ash' || name === 'Ash Grey') return '99% cotton / 1% polyester';
     if (name === 'Sport Grey' || (item.id === '5000' && name.startsWith('Antique ')) || (item.id === '5000B' && name === 'Antique Jade Dome')) return '90% cotton / 10% polyester';
     const mixed = name.includes('Heather') || name.startsWith('Neon ') || name.startsWith('Safety ') || (item.id === '5000' && ['Blackberry', 'Lilac', 'Midnight', 'Sunset', 'Tweed'].includes(name));
     if (mixed) return '50% cotton / 50% polyester';
   }
   if (item.id === 'WERK250') {
     if (name === 'Athletic Grey') return '90% cotton / 10% viscose';
     if (name === 'Safety Orange' || name === 'Safety Yellow') return '65% polyester / 35% cotton';
   }
   if (item.id === '18500' && ['Heather Dark Green', 'Heather Dark Maroon', 'Heather Dark Navy', 'Heather Deep Royal', 'Heather Scarlet Red'].includes(name)) return '60% polyester / 40% cotton';
   if (item.id === 'IND4000Z') {
     if (name.includes('Heather')) return '52% cotton / 48% polyester';
     if (name === 'Forest Camo') return '75% cotton / 25% polyester';
   }
   if (item.id === '2400') {
     if (name === 'Ash') return '99% cotton / 1% polyester';
     if (name === 'Sport Grey') return '90% cotton / 10% polyester';
     if (name === 'Dark Heather' || name.startsWith('Safety ')) return '50% cotton / 50% polyester';
   }
   if (item.id === '8800') {
     if (name === 'Sport Grey') return '90% cotton / 10% polyester';
     if (name === 'Graphite Heather') return '62% cotton / 38% polyester';
   }
   if (item.id === '18000' && name.startsWith('Heather ')) return '60% polyester / 40% cotton';
   if (item.id === 'SF000') {
     if (name === 'Dark Heather') return '50% cotton / 50% polyester';
     if (name === 'Sport Grey') return '75% cotton / 25% polyester';
   }
   if (item.id === 'S05610' && name.includes('Heather')) return '65% ring-spun combed cotton / 35% polyester jersey';
   if (item.id === 'L00550' && name.includes('Heather')) return '60% ring-spun combed cotton / 40% polyester fleece';
   return item.fabric;
 }
 function renderSpecs() {
   const fabric = fabricFor(selected, color.name);
   $('[data-kp-spec-heading]').textContent = selected.name;
   $('[data-kp-spec-summary]').textContent = [fabric, selected.weight, selected.fit].filter(Boolean).join(' · ');
   $('[data-kp-spec-fabric]').textContent = `${fabric} · ${color.name}`;
   $('[data-kp-spec-weight]').textContent = selected.weight;
   $('[data-kp-spec-fit]').textContent = selected.fit || 'Not specified by supplier';
   $('[data-kp-spec-features]').textContent = selected.features;
   $('[data-kp-spec-sizes]').textContent = selected.sizes.join(', ');
   $('[data-kp-spec-note]').textContent = selected.blendNote || '';
   renderMeasurements();
 }
 function renderMeasurements() {
   const intro = $('[data-kp-measure-intro]');
   const table = $('[data-kp-measure-table]');
   const foot = $('[data-kp-measure-footnote]');
   const data = selected.measurements;
   table.hidden = !data;
   if (!data) {
     intro.textContent = selected.dimensionNote || 'A verified garment measurement table for this style is pending. Please contact us for fit guidance before ordering.';
     foot.textContent = '';
     return;
   }
   intro.textContent = 'Finished garment dimensions in inches, measured on the garment. These are not body measurements.';
   const head = table.querySelector('thead'), body = table.querySelector('tbody');
   head.replaceChildren(); body.replaceChildren();
   const heading = document.createElement('tr');
   ['Measurement', ...selected.sizes].forEach(value => { const cell = document.createElement('th'); cell.scope = 'col'; cell.textContent = value; heading.append(cell); });
   head.append(heading);
   [[data.chestLabel, data.chest], ['Body length', data.length]].forEach(([label, values]) => {
     const row = document.createElement('tr'); const title = document.createElement('th'); title.scope = 'row'; title.textContent = label; row.append(title);
     values.forEach(value => { const cell = document.createElement('td'); cell.textContent = value; row.append(cell); }); body.append(row);
   });
   foot.textContent = `${data.footnote} Source: ${selected.source.includes('ssactivewear') ? 'S&S Canada product specs' : selected.id === 'HERO300' ? 'Just Like Hero size chart' : 'manufacturer PDF'}.`;
 }
 function renderColors() {
   const choices = colorsFor(selected);
   const host = $('[data-kp-colors]'); host.replaceChildren();
   host.classList.toggle('kp-apparel__colors--expanded', colorExpanded);
   const toggle = $('[data-kp-show-colors]');
   toggle.hidden = choices.length <= 12;
   toggle.setAttribute('aria-expanded', String(colorExpanded));
   toggle.textContent = colorExpanded ? 'Show fewer colors' : 'Show more colors';
   (colorExpanded ? choices : choices.slice(0, 12)).forEach(entry => {
     const button = document.createElement('button'); button.type = 'button'; button.className = 'kp-apparel__color';
     button.setAttribute('aria-label', entry.name); button.title = entry.name;
     button.setAttribute('aria-pressed', String(entry.name === color.name));
     const src = photoFor(selected, entry);
     if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.loading = 'lazy'; button.append(img); }
     else { const chip = document.createElement('span'); chip.className = 'kp-apparel__color-chip'; chip.style.setProperty('--kp-chip', fallbackColors[entry.name] || '#dcdde1'); chip.setAttribute('aria-hidden', 'true'); if (selected.verifiedMedia) { chip.textContent = '?'; button.title += ' · photo unavailable'; } button.append(chip); }
     button.addEventListener('click', () => {
       color = entry;
       host.querySelectorAll('button').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
       renderImage();
       $('[data-kp-chosen]').textContent = `Selected color: ${color.name}`;
       renderSpecs();
       renderSummary();
     });
     host.append(button);
   });
 }
 const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
 const roundedInches = value => String(Math.max(.01, Math.round(value * 100) / 100));
 function reconcileDimensions(area) {
   const pref = sidePrefs[area], art = artwork[area];
   if (!art?.ratio) return;
   if (selected.type === 'hat' && !pref.width && !pref.height) {
     const limit = apparelPrintLimit(retailPricing.models[selected.id],area);
     const width = Math.min(limit.maxPrintWidthIn, limit.maxPrintHeightIn * art.ratio);
     pref.width = roundedInches(width); pref.height = roundedInches(width / art.ratio);
   }
   if (Number(pref.width) > 0) pref.height = roundedInches(Number(pref.width) / art.ratio);
   else if (Number(pref.height) > 0) pref.width = roundedInches(Number(pref.height) * art.ratio);
 }
 function updateMigrationNotice() {
   const legacy = Object.keys(areas).filter(area => artwork[area]?.legacyUnsupported);
   const reminder = legacy.length ? `Saved ${legacy.map(area => `${area} ${artwork[area].name}`).join(' and ')} remains on this device for reference. Re-upload PNG, JPEG or PDF artwork for the preview and email the original separately.` : '';
   const text = [migrationNotice, storageWarning, reminder].filter(Boolean).join(' ');
   $('[data-kp-migration-notice]').textContent = text;
   $('[data-kp-migration-notice]').hidden = !text;
 }
 function syncDimensionUI(activeDimension = '') {
   const pref = sidePrefs[view], art = artwork[view];
   if (activeDimension !== 'width') $('[data-kp-print-width]').value = pref.width;
   if (activeDimension !== 'height') $('[data-kp-print-height]').value = pref.height;
   $('[data-kp-pantone]').value = pref.pantone;
   $('[data-kp-pantone-label]').textContent = `${areas[view]} artwork Pantone Solid Coated references`;
   const limit = apparelPrintLimit(retailPricing.models[selected.id],view);
   root.querySelectorAll('[data-kp-print-width],[data-kp-print-height]').forEach(input => {
     const maximum = input.hasAttribute('data-kp-print-width') ? (limit?.maxPrintWidthIn || 30) : (limit?.maxPrintHeightIn || 30);
     input.max = String(maximum);
     if (input !== document.activeElement || !activeDimension) input.setAttribute('aria-invalid', String(input.value !== '' && (!Number.isFinite(Number(input.value)) || Number(input.value) <= 0 || Number(input.value) > maximum)));
   });
   $('[data-kp-dimension-note]').textContent = art?.url
     ? `The other dimension follows your artwork proportions. ${previewScaleNote()}`
     : art ? 'This saved file cannot be previewed. Re-upload a PNG, JPEG or PDF; your original remains on this device.'
       : 'Enter one dimension after uploading artwork; the other follows its proportions. Preview size is approximate.';
   if (limit?.maxPrintWidthIn) $('[data-kp-dimension-note]').textContent += ` ${areas[view]} planning limit: ${limit.maxPrintWidthIn} × ${limit.maxPrintHeightIn} in${limit.description ? ' · '+limit.description : ''}. We review the fit and placement before production.`;
   else if (selected.type === 'hat' || selected.type === 'bag') $('[data-kp-dimension-note]').textContent += ' Hat limits await approved dimensions; supplier areas are preview references only.';
   const quality = $('[data-kp-quality-note]');
   const width = Number(pref.width), height = Number(pref.height);
   if (art?.url && art.pixelWidth && art.pixelHeight && width > 0 && height > 0) {
     const effective = Math.min(art.pixelWidth / width, art.pixelHeight / height);
     quality.hidden = effective >= 300;
     if (!quality.hidden) quality.textContent = `This artwork may look blurry at your requested print size. Kippush can review it and offer free enhancement; we may ask for a clearer original.`;
   } else quality.hidden = true;
 }
 function setRequestedDimension(dimension, input) {
   const raw=input.value.trim(),number=Number(raw),pref=sidePrefs[view],art=artwork[view],limit=apparelPrintLimit(retailPricing.models[selected.id],view);
   pref[dimension]=raw;
   if(art?.ratio){const other=dimension==='width'?'height':'width';pref[other]=raw===''?'':Number.isFinite(number)&&number>0?String(Math.round((dimension==='width'?number/art.ratio:number*art.ratio)*10000)/10000):'';}
   const width=Number(pref.width),height=Number(pref.height);
   const valid=!input.validity.badInput&&(raw===''||validArtworkDimensions(width,height,limit));
   input.setAttribute('aria-invalid',String(!valid));
   syncDimensionUI(dimension);
   if(!valid){$('[data-kp-dimension-note]').textContent=limit?.maxPrintWidthIn?`Maximum is ${limit.maxPrintWidthIn} in wide × ${limit.maxPrintHeightIn} in high. Your linked artwork must fit both limits. Correct the dimensions to refresh the estimate.`:'Enter positive print dimensions. This category needs print-area approval.';renderSummary();return;}
   if(art?.url&&width>0&&height>0)updateOverlay(false);
   renderSummary();
 }
 function parseInches(value) {
   const parts = String(value || '').trim().split(/\s+/);
   const inches = parts.reduce((sum, part) => {
     if (part.includes('/')) { const [top, bottom] = part.split('/').map(Number); return sum + (bottom ? top / bottom : 0); }
     return sum + (Number(part) || 0);
   }, 0);
   return inches > 0 ? inches : null;
 }
 function referenceChest() {
   const data = selected.measurements;
   const index = selected.sizes.indexOf('M');
   if (!data || index < 0) return null;
   const label = data.chestLabel.toLowerCase();
   const listed = parseInches(data.chest[index]);
   if (!listed) return null;
   if (label.includes('laid flat') || label.includes('half measure')) return listed;
   if (label.includes('circumference')) return listed / 2;
   return null;
 }
 function previewScaleNote() {
   if (selected.type === 'hat') return 'Approximate front-panel concept using the owner planning envelope of 4.5 in wide × 2.5 in high. Actual fit, decoration method, compatibility and placement require review.';
   if (selected.type === 'bag') return `Approximate bag-body concept using the 12 in wide × 16 in high planning envelope. The supplier suggests ${selected.suggestedPrintWidth} × ${selected.suggestedPrintHeight} in; actual fit, decoration and usable area require review.`;
   const chest = referenceChest();
   return chest
     ? `Approximate on a size M garment (listed chest width ${roundedInches(chest)} in). Print area and placement need confirmation; other garment sizes may differ.`
     : 'Approximate relative size preview only; a verified chest or print-area calibration is unavailable for this style.';
 }
 function planningZone(area) { return selected.sideZones?.[area] || selected.zone || [.24,.76,.25,.68]; }
 function defaultArtworkY(area = view) { const z=planningZone(area);return (z[2]+z[3])*50; }
 function defaultArtworkX(area) { const z=planningZone(area);return (z[0]+z[1])*50; }
 function zonePixelsPerInch(region,box,area) {
   const limit=apparelPrintLimit(retailPricing.models[selected.id],area);
   if(selected.sideZones?.[area] || selected.type==='hat' || selected.type==='bag') return Math.min(region.width/limit.maxPrintWidthIn,region.height/limit.maxPrintHeightIn);
   return selected.suggestedPrintWidth ? region.width/selected.suggestedPrintWidth : referenceChest() ? region.width/referenceChest() : box.width*.028;
 }
 function artworkLayout(art) {
   const garment = stage.querySelector('.kp-apparel__garment');
   const stageWidth = stage.clientWidth, stageHeight = stage.clientHeight;
   let box = { left: 0, top: 0, width: stageWidth, height: stageHeight };
   if (garment && garment.naturalWidth && garment.naturalHeight) {
     const fit = Math.min(stageWidth / garment.naturalWidth, stageHeight / garment.naturalHeight);
     const zoom = Number(garment.dataset.kpZoom) || 1;
     box = { width: garment.naturalWidth * fit * zoom, height: garment.naturalHeight * fit * zoom };
     box.left = (stageWidth - box.width) / 2; box.top = (stageHeight - box.height) / 2;
   }
   const bounds = planningZone(view);
   const region = bounds ? { left: box.left + box.width * bounds[0], right: box.left + box.width * bounds[1], top: box.top + box.height * bounds[2], bottom: box.top + box.height * bounds[3] } : { left: box.left + box.width * (selected.id === 'IND4000Z' && view === 'front' ? .16 : .24), right: box.left + box.width * .76, top: box.top + box.height * .25, bottom: box.top + box.height * .68 };
   region.width = region.right - region.left; region.height = region.bottom - region.top;
   const base = box.width * .28;
   const ratio = art.ratio || 1;
   const maxWidth = Math.min(region.width, region.height * ratio);
   const minWidth = Math.min(maxWidth, Math.max(12, box.width * .025));
   const limit = apparelPrintLimit(retailPricing.models[selected.id],view);
   const pixelsPerInch = zonePixelsPerInch(region,box,view);
   const boundedWidth = Math.min(maxWidth, (limit?.maxPrintWidthIn || Infinity) * pixelsPerInch, (limit?.maxPrintHeightIn || Infinity) * pixelsPerInch * ratio);
   return { box, region, base, ratio, maxWidth: boundedWidth, minWidth: Math.min(minWidth, boundedWidth), pixelsPerInch };
 }
 function updateOverlay(syncRequested = false) {
   const overlay = stage.querySelector('.kp-apparel__artwork');
   const art = artwork[view];
   if (!overlay || !art || !stage.clientWidth) return null;
   const layout = artworkLayout(art);
   const requestedWidth = Number(sidePrefs[view].width);
   const targetWidth = syncRequested ? layout.base * art.scale / 100
     : requestedWidth > 0 ? requestedWidth * layout.pixelsPerInch : layout.base * art.scale / 100;
   const width = syncRequested ? clamp(targetWidth, layout.minWidth, layout.maxWidth) : Math.min(Math.max(targetWidth, Number.EPSILON), layout.maxWidth);
   const height = width / layout.ratio;
   if (syncRequested && art.ratio) {
     sidePrefs[view].width = roundedInches(width / layout.pixelsPerInch);
     sidePrefs[view].height = roundedInches(Number(sidePrefs[view].width) / art.ratio);
     syncDimensionUI();
   }
   let centerX = layout.box.left + layout.box.width * art.x / 100;
   let centerY = layout.box.top + layout.box.height * art.y / 100;
   centerX = clamp(centerX, layout.region.left + width / 2, layout.region.right - width / 2);
   centerY = clamp(centerY, layout.region.top + height / 2, layout.region.bottom - height / 2);
   art.x = (centerX - layout.box.left) / layout.box.width * 100;
   art.y = (centerY - layout.box.top) / layout.box.height * 100;
   art.scale = width / layout.base * 100;
   art.renderedScale = art.scale;
   overlay.style.left = `${centerX}px`;
   overlay.style.top = `${centerY}px`;
   overlay.style.width = `${width}px`;
   overlay.style.height = `${height}px`;
   overlay.setAttribute('aria-label', `${areas[view]} artwork. Drag to move. Drag a corner to resize. Arrow keys move; plus and minus resize.`);
   renderSummary();
   return { ...layout, width, height, centerX, centerY };
 }
 function renderThumbnail() {
   $('[data-kp-side-thumb]').hidden = supportedAreas().length < 2;
   if (supportedAreas().length < 2) return;
   const other = view === 'front' ? 'back' : 'front';
   const button = $('[data-kp-side-thumb]');
   const canvas = $('[data-kp-side-thumb-canvas]');
   button.setAttribute('aria-label', `Show ${other} garment preview${artwork[other] ? ` with ${artwork[other].name}` : ''}`);
   $('[data-kp-side-thumb-label]').textContent = `${areas[other]}${artwork[other] ? ' · art' : ''} · view`;
   canvas.replaceChildren();
   const src = photoFor(selected, color, other);
   const art = artwork[other];
   if (!src) {
     const empty = document.createElement('span'); empty.className = 'kp-apparel__side-thumb-empty'; empty.textContent = `${areas[other]} photo unavailable`; canvas.append(empty);
     if (art?.url) {
       const print = document.createElement('img'); print.className = 'kp-apparel__side-thumb-art'; print.src = art.url; print.alt = '';
       const ratio = art.ratio || 1, width = clamp(Number(sidePrefs[other].width) > 0 ? Number(sidePrefs[other].width) * canvas.clientWidth * .028 : canvas.clientWidth * .28 * art.scale / 100, 3, Math.min(canvas.clientWidth * .52, canvas.clientHeight * .43 * ratio));
       Object.assign(print.style, { left: `${canvas.clientWidth / 2}px`, top: `${canvas.clientHeight * .45}px`, width: `${width}px`, height: `${width / ratio}px` });
       canvas.append(print);
     }
     return;
   }
   const garment = document.createElement('img'); garment.className = 'kp-apparel__side-thumb-garment'; garment.alt = '';
   garment.onload = () => {
     if (!art?.url || !garment.naturalWidth || !garment.naturalHeight) return;
     const scale = Math.min(canvas.clientWidth / garment.naturalWidth, canvas.clientHeight / garment.naturalHeight);
     const box = { width: garment.naturalWidth * scale, height: garment.naturalHeight * scale };
     box.left = (canvas.clientWidth - box.width) / 2; box.top = (canvas.clientHeight - box.height) / 2;
     const bounds = planningZone(other);
   const region = bounds ? { left: box.left + box.width * bounds[0], right: box.left + box.width * bounds[1], top: box.top + box.height * bounds[2], bottom: box.top + box.height * bounds[3] } : { left: box.left + box.width * .24, right: box.left + box.width * .76, top: box.top + box.height * .25, bottom: box.top + box.height * .68 };
     const ratio = art.ratio || 1, base = box.width * .28;
     region.width=region.right-region.left;region.height=region.bottom-region.top;
     const pxPerInch=zonePixelsPerInch(region,box,other);
     const sideLimit=apparelPrintLimit(retailPricing.models[selected.id],other);
     const requested = Number(sidePrefs[other].width);
     const width = clamp(requested > 0 ? requested * pxPerInch : base * art.scale / 100, 3, Math.min(region.width,region.height*ratio,sideLimit.maxPrintWidthIn*pxPerInch,sideLimit.maxPrintHeightIn*pxPerInch*ratio));
     const height = width / ratio;
     const centerX = clamp(box.left + box.width * art.x / 100, region.left + width / 2, region.right - width / 2);
     const centerY = clamp(box.top + box.height * art.y / 100, region.top + height / 2, region.bottom - height / 2);
     const print = document.createElement('img'); print.className = 'kp-apparel__side-thumb-art'; print.src = art.url; print.alt = '';
     Object.assign(print.style, { left: `${centerX}px`, top: `${centerY}px`, width: `${width}px`, height: `${height}px` });
     canvas.append(print);
   };
   canvas.append(garment); garment.src = src;
 }
 function addArtworkOverlay() {
   if (selected.type === 'hat' && hatProductView !== 'front') return;
   const art = artwork[view];
   if (!art) return;
   if (!art.url) {
     const badge = document.createElement('div'); badge.className = 'kp-apparel__source-file'; badge.setAttribute('role', 'status');
     const icon = document.createElement('b'); icon.textContent = art.kind.toUpperCase(); icon.setAttribute('aria-hidden', 'true');
     const text = document.createElement('span'); const name = document.createElement('strong'); name.textContent = art.name;
     const detail = document.createElement('small'); detail.textContent = 'Saved for reference · re-upload as PNG, JPEG or PDF';
     text.append(name, detail); badge.append(icon, text); stage.append(badge); return;
   }
   const overlay = document.createElement('div'); overlay.className = 'kp-apparel__artwork'; overlay.tabIndex = 0; overlay.setAttribute('role', 'group');
   const img = document.createElement('img'); img.src = art.url; img.alt = ''; overlay.append(img);
   ['nw', 'ne', 'sw', 'se'].forEach(corner => {
     const handle = document.createElement('span'); handle.className = 'kp-apparel__handle'; handle.dataset.corner = corner; handle.setAttribute('aria-hidden', 'true'); overlay.append(handle);
   });
   stage.append(overlay);
   updateOverlay();
   let gesture = null;
   overlay.addEventListener('pointerdown', event => {
     if (event.pointerType === 'mouse' && event.button !== 0) return;
     const metrics = updateOverlay(); if (!metrics) return;
     event.preventDefault(); overlay.focus({ preventScroll: true }); overlay.setPointerCapture(event.pointerId);
     const corner = event.target.closest('[data-corner]')?.dataset.corner;
     gesture = { id: event.pointerId, corner, startX: event.clientX, startY: event.clientY, x: art.x, y: art.y, scale: art.scale, width: sidePrefs[view].width, height: sidePrefs[view].height, metrics };
     overlay.classList.add('is-dragging');
   });
   overlay.addEventListener('pointermove', event => {
     if (!gesture || event.pointerId !== gesture.id) return;
     const g = gesture, dx = event.clientX - g.startX, dy = event.clientY - g.startY;
     if (g.corner) {
       const sx = g.corner.includes('e') ? 1 : -1, sy = g.corner.includes('s') ? 1 : -1;
       const anchorX = g.metrics.centerX - sx * g.metrics.width / 2;
       const anchorY = g.metrics.centerY - sy * g.metrics.height / 2;
       const horizontalReach = sx > 0 ? g.metrics.region.right - anchorX : anchorX - g.metrics.region.left;
       const verticalReach = sy > 0 ? g.metrics.region.bottom - anchorY : anchorY - g.metrics.region.top;
       const maxWidth = Math.min(g.metrics.maxWidth, horizontalReach, verticalReach * g.metrics.ratio);
       const minWidth = Math.min(g.metrics.minWidth, maxWidth);
       const deltaWidth = (sx * dx + sy * dy * g.metrics.ratio) / 2;
       const width = clamp(g.metrics.width + deltaWidth, minWidth, maxWidth);
       art.scale = width / g.metrics.base * 100;
       art.x = (anchorX + sx * width / 2 - g.metrics.box.left) / g.metrics.box.width * 100;
       art.y = (anchorY + sy * width / g.metrics.ratio / 2 - g.metrics.box.top) / g.metrics.box.height * 100;
     } else {
       art.x = g.x + dx / g.metrics.box.width * 100;
       art.y = g.y + dy / g.metrics.box.height * 100;
     }
     updateOverlay(Boolean(g.corner));
   });
   const finish = event => {
     if (!gesture || event.pointerId !== gesture.id) return;
     if (event.type === 'pointercancel') { art.x = gesture.x; art.y = gesture.y; art.scale = gesture.scale; sidePrefs[view].width = gesture.width; sidePrefs[view].height = gesture.height; updateOverlay(); syncDimensionUI(); }
     gesture = null; overlay.classList.remove('is-dragging');
     if (overlay.hasPointerCapture(event.pointerId)) overlay.releasePointerCapture(event.pointerId);
   };
   overlay.addEventListener('pointerup', finish);
   overlay.addEventListener('pointercancel', finish);
   overlay.addEventListener('lostpointercapture', () => { gesture = null; overlay.classList.remove('is-dragging'); });
   overlay.addEventListener('keydown', event => {
     const step = event.shiftKey ? 5 : 1;
     if (event.key === 'ArrowLeft') art.x -= step;
     else if (event.key === 'ArrowRight') art.x += step;
     else if (event.key === 'ArrowUp') art.y -= step;
     else if (event.key === 'ArrowDown') art.y += step;
     else if (event.key === '+' || event.key === '=' || event.key === 'Add') art.scale += 5;
     else if (event.key === '-' || event.key === '_' || event.key === 'Subtract') art.scale -= 5;
     else return;
     event.preventDefault(); updateOverlay(event.key === '+' || event.key === '=' || event.key === 'Add' || event.key === '-' || event.key === '_' || event.key === 'Subtract');
   });
 }
 function renderSchematic(message) {
   const empty = document.createElement('div'); empty.className = 'kp-apparel__preview-empty';
   empty.textContent = `${areas[view]} garment photo unavailable. Artwork placement is shown on a plain canvas.`;
   stage.append(empty);
   $('[data-kp-preview-note]').textContent = message;
   addArtworkOverlay();
 }

 let hatProductView = 'front';
 let hatGalleryModel = null;
 function renderHatGallery() {
   const host = $('[data-kp-hat-gallery]'), images = $('[data-kp-hat-gallery-images]');
   if (hatGalleryModel !== selected.id) { hatProductView = 'front'; hatGalleryModel = selected.id; }
   images.replaceChildren(); host.hidden = selected.type !== 'hat';
   if (host.hidden) return;
   const sources = {front: photoFor(selected, color), ...(selected.galleryImages?.[color.name] || {})};
   for (const side of ['front','side','back']) {
     const label = side[0].toUpperCase() + side.slice(1);
     const button = document.createElement('button'); button.type = 'button'; button.dataset.kpProductView = side;
     button.setAttribute('aria-label', `Show ${side} hat preview · ${color.name}`);
     button.setAttribute('aria-pressed', String(hatProductView === side));
     const name = document.createElement('span'); name.textContent = label;
     const src = sources[side];
     if (src) {
       const image = document.createElement('img'); image.src = src; image.alt = `${selected.name} in ${color.name}, ${side} product-only view`;
       image.onerror = () => { image.remove(); name.textContent = `${label} unavailable`; button.disabled = true; };
       button.append(image);
       button.addEventListener('click', () => { hatProductView = side; renderImage(); });
     } else { button.disabled = true; name.textContent = `${label} unavailable`; }
     button.append(name); images.append(button);
   }
 }
 function renderImage() {
   renderHatGallery();
   const request = ++imageRequest;
   stage.replaceChildren();
   renderThumbnail();
   const productView = selected.type === 'hat' ? hatProductView : view;
   const viewingArtwork = selected.type !== 'hat' || productView === 'front';
   $('[data-kp-art-controls]').hidden = !viewingArtwork || !artwork[view]?.url;
   const src = selected.type === 'hat' && productView !== 'front' ? selected.galleryImages?.[color.name]?.[productView] || '' : photoFor(selected, color, view);
   if (!src) {
     renderSchematic(`A ${areas[view].toLowerCase()} photo is not available for ${color.name}. Artwork placement is a guide.`);
     return;
   }
   const img = document.createElement('img'); img.className = 'kp-apparel__garment';
   img.dataset.kpZoom = String(previewZoom(selected));
   img.style.setProperty('--kp-preview-zoom', img.dataset.kpZoom);
   img.alt = `${selected.name} in ${color.name}, ${productView} garment-only view`;
   img.onload = () => { if (request !== imageRequest) return; if (viewingArtwork) { addArtworkOverlay(); updateOverlay(); } };
   img.onerror = () => {
     if (request !== imageRequest) return;
     stage.replaceChildren(); renderSchematic(`A ${areas[view].toLowerCase()} photo is not available for ${color.name}. Artwork placement is a guide.`);
   };
   stage.append(img);
   $('[data-kp-preview-note]').textContent = selected.decorationReview ? 'Proposed decoration placement only · method, compatibility and usable area require review.' : 'Artwork placement is a guide. We will confirm the final print details with you.';
   if (selected.type === 'hat' && productView !== 'front') $('[data-kp-preview-note]').textContent = `${productView === 'side' ? 'Side' : 'Back'} product view only. Printing stays on the front panel; choose Front to preview your artwork.`;
   img.src = src;
 }
 function renderArtUI() {
   root.querySelectorAll('[data-kp-view]').forEach(button => {
     button.hidden = !supportedAreas().includes(button.dataset.kpView);
     button.textContent = areas[button.dataset.kpView];
     button.setAttribute('aria-pressed', String(button.dataset.kpView === view));
     button.classList.toggle('kp-apparel__has-art', Boolean(artwork[button.dataset.kpView]));
   });
   const art = artwork[view];
   $('[data-kp-upload-label]').textContent = `${art ? 'Change' : 'Add'} artwork for ${areas[view]}`;
   $('[data-kp-art-remove]').textContent = `Remove ${areas[view].toLowerCase()} artwork`;
   $('[data-kp-art-remove]').hidden = !art;
   $('[data-kp-art-controls]').hidden = !art?.url;
   $('[data-kp-reset-all]').hidden = !Object.values(artwork).some(Boolean);
   if (art) {
     const format=art.kind==='jpeg'?'JPEG':art.kind==='pdf'?'PDF':'PNG';
     $('[data-kp-file-note]').textContent = art.legacyUnsupported
       ? `${art.name} was saved previously. Re-upload a PNG, JPEG or PDF; the original remains on this device.`
       : storageWarning || `${art.name} · ${areas[view].toLowerCase()} ${format} artwork`;
   } else {
     $('[data-kp-file-note]').textContent = storageWarning || 'PNG, JPG, JPEG or PDF · 10 MB max';
   }
   const basis=$('[data-kp-artwork-basis]');
   basis.hidden=!art?.url;
   basis.textContent=art?.alphaBounds
     ? `Visible artwork: ${art.pixelWidth} × ${art.pixelHeight} px, trimmed from ${art.originalWidth} × ${art.originalHeight} px. ${art.resolution.label} Original PNG retained for production.${art.maxFitAdjusted?' Size was reduced proportionally to fit the maximum; confirm it before ordering.':''}`
     : art?.kind==='jpeg'&&art.url ? `JPEG canvas: ${art.pixelWidth} × ${art.pixelHeight} px. Background retained exactly; transparency is not inferred. ${art.resolution.label}. Original JPEG retained for production.${art.maxFitAdjusted?' Size was reduced proportionally to fit the maximum; confirm it before ordering.':''}`
     : art?.kind==='pdf'&&art.url ? `PDF page ${art.pdfPage} of ${art.pdfPages}: ${art.pixelWidth} × ${art.pixelHeight} px preview. Original PDF retained for production with the selected page number.${art.maxFitAdjusted?' Size was reduced proportionally to fit the maximum; confirm it before ordering.':''}` : '';
   const pdfControl=$('[data-kp-pdf-page-control]'),pdfSelect=$('[data-kp-pdf-page]');
   pdfControl.hidden=art?.kind!=='pdf'||!art?.pdfPages;
   if(!pdfControl.hidden){
     if(pdfSelect.options.length!==art.pdfPages){
       pdfSelect.replaceChildren(...Array.from({length:art.pdfPages},(_,index)=>{const option=document.createElement('option');option.value=String(index+1);option.textContent=`Page ${index+1} of ${art.pdfPages}`;return option;}));
     }
     pdfSelect.value=String(art.pdfPage);
   }
   updateMigrationNotice();
   syncDimensionUI();
   renderSummary();
 }
 function renderEstimate(quantity) {
   const invalid = Boolean(root.querySelector('.kp-apparel__size input[aria-invalid="true"], [data-kp-print-width][aria-invalid="true"], [data-kp-print-height][aria-invalid="true"]'));
   const prints = supportedAreas().filter(side => artwork[side]).map(side => ({ side, hasArtwork: Boolean(artwork[side].url && !artwork[side].legacyUnsupported), width: Number(sidePrefs[side].width), height: Number(sidePrefs[side].height) }));
   const sizes = [...root.querySelectorAll('.kp-apparel__size input')].map(input => ({size:input.dataset.size, quantity:Number(input.value || 0)}));
   let estimate = calculateApparelEstimate(retailPricing, selected.id, sizes, prints, invalid);
   if (estimate.sides) {
     if (selected.suggestedPrintWidth && prints.some(p => p.width > selected.suggestedPrintWidth || p.height > selected.suggestedPrintHeight)) estimate.holds.push('print-area-review');
     if (prints.some(p => !photoFor(selected, color, p.side))) estimate.holds.push('media-review');
     if (estimate.holds.length) { estimate.status = 'review-required'; estimate.message = 'Estimate for review · approval required'; }
   }
   currentEstimate = estimate;
   const marketEstimate=presentmentApparelEstimate(estimate);
   const marketEntry=cartSellability.get(cartSellabilityKey());
   const hasPricedSelection=Boolean(estimate.sizeLines?.length);
   const marketUnavailable=Boolean(hasPricedSelection&&!marketEstimate&&(!checkoutModelIsEnabled()||marketEntry?.status==='unavailable'||marketEntry?.status==='ready'));
   const marketPending=Boolean(hasPricedSelection&&!marketEstimate&&!marketUnavailable);
   let shown=marketEstimate||(marketUnavailable?{...estimate,status:'quote-only',message:'Published prices for this selected market could not be verified. Contact us for a reviewed quote.',currency:marketEntry?.currency||window.Shopify?.currency?.active,total:null,marketUnavailable:true}:marketPending?{...estimate,total:null,currency:marketEntry?.currency||window.Shopify?.currency?.active,marketPending:true}:estimate);
   const presentmentCartFinalOnly=shown.currency==='USD'&&shown.presentmentTierDerived===true&&shown.sides?.length>0;
   if(presentmentCartFinalOnly)shown={...shown,message:'Your discount and final price will be shown in your cart.',total:null,perItem:null,printing:null,printingTotal:null,sides:shown.sides.map(side=>({...side,retail:null})),sizeLines:shown.sizeLines.map(line=>({...line,printing:null,perItem:null,total:null})),presentmentCartFinalOnly:true};
   const shownCurrency=marketEstimate?.currency||marketEntry?.currency||window.Shopify?.currency?.active||estimate.currency;
   const verifiedPrice=apparelPriceDisplayIsVerified(shown,marketEstimate,shownCurrency,checkoutModelIsEnabled());
   shown.priceDisplayVerified=verifiedPrice;
   estimate=shown;
   $('[data-kp-estimate]').dataset.estimateState = shown.status;
   $('#kp-apparel-estimate-heading').textContent=`Price${marketPending?'':` (${shownCurrency})`}`;
   $('[data-kp-estimate-status]').textContent = marketPending?'Checking prices':verifiedPrice?`${quantity} ${quantity===1?'item':'items'}`:shown.presentmentCartFinalOnly?'Price shown in cart':shown.status==='quote-only'?'Quote required':shown.sizeLines?.length?'Price confirmation required':'Choose sizes';
   $('[data-kp-estimate-message]').textContent = marketPending?'Checking published prices.':verifiedPrice?(shown.sides.length?(shown.presentmentTierDerived?'Includes printing and quantity discount. Tax and shipping extra.':'Includes selected printing. Tax and shipping extra.'):'Blank garments. Tax and shipping extra.'):shown.presentmentCartFinalOnly?'Price shown in cart. Tax and shipping extra.':shown.message;
   const lines = $('[data-kp-estimate-lines]'); lines.replaceChildren(); lines.hidden = !verifiedPrice;
   const format = amount => new Intl.NumberFormat('en-CA', { style: 'currency', currency: shownCurrency }).format(amount);
   if (verifiedPrice) {
     const row = (label, amount) => { const wrap = document.createElement('div'), term = document.createElement('dt'), result = document.createElement('dd'); term.textContent = label; result.textContent = format(amount); wrap.append(term, result); lines.append(wrap); };
     if(Number.isFinite(estimate.perItem))row('Price per item',estimate.perItem);
     else estimate.sizeLines.forEach(line=>row(`Price per item - ${line.size} (x${line.quantity})`,line.perItem));
     row(`Total (${shownCurrency})`, estimate.total);
   }
   const review = [];
   if (estimate.presentmentCartFinalOnly) review.push('Your discount and final price will be shown in your cart.');
   else if (estimate.presentmentTierDerived) review.push('Market garment and base print prices come from published Shopify variants. The print-only quantity break is estimated proportionally and the cart confirms its final rounded amount.');
   if (estimate.holds.includes('quantity-review')) review.push(`Provisional quantity pricing uses the ${estimate.tier}-item break for ${quantity} items. Final pricing needs confirmation.`);
   if (estimate.holds.includes('fit-review')) review.push('Print dimensions validate fit only; the printing price is flat per selected side. Actual placement and fit require approval.');
   if (estimate.sizeLines?.some(x => x.sizeAdjustmentEstimated)) review.push('Some larger-size garment prices include an estimated supplier size adjustment approved for this draft; final availability and production require confirmation.');
   if (estimate.holds.includes('planning-area-review')) review.push('Planning zones are approximate. We confirm placement on the selected garment size before production; keep clear of zippers, plackets, pockets and seams.');
   if (estimate.holds.includes('cap-size-review')) review.push('The 4.5 in wide × 2.5 in high hat planning limit still needs supplier physical-fit and decoration approval before production.');
   if (estimate.holds.includes('technique-review')) review.push('Supplier technique approval is pending. Confirm material, heat safety, printable area and any surcharge.');
   if (estimate.holds.includes('specification-review')) review.push(selected.id==='S05610'?'S05610 garment retail is approved. Larger-size supplier costs were estimated in the pricing workbook; fabric details, fit and placement are reviewed before production.':'Fabric specification requires review before production.');

   if (estimate.holds.includes('print-limit-review')) review.push('Maximum print dimensions for this product are not approved. Confirm usable area and decoration before ordering.');
   if(estimate.holds.includes('availability-review'))review.push(pilotManifest.enabledModels?.includes(selected.id)?'Availability confirmed for this pilot style; final stock is checked before production.':'Availability remains pending. Contact us for an approved quote.');
   if (estimate.holds.includes('print-area-review')) review.push('Requested print exceeds the supplier suggested area. Placement and pricing need review.');
   if (estimate.holds.includes('media-review')) review.push('A selected-side photo is unavailable or withheld. Confirm placement before quoting.');
   const note = $('[data-kp-estimate-review]'); note.textContent = verifiedPrice?(estimate.sides.length?'Artwork, fit and garment specifications are reviewed before production.':''):estimate.presentmentCartFinalOnly?'Artwork approval is required before production.':review.join(' '); note.hidden = !note.textContent;
   return estimate;
 }
 function renderPrintRates(quantity) {
   const model=retailPricing.models[selected.id],table=$('[data-kp-print-rates-table]'),body=table.querySelector('tbody');body.replaceChildren();
   table.hidden=!model?.printClass;
   const limits=model?.sideLimits ? Object.entries(model.sideLimits).map(([side,limit])=>`${areas[side]} ${limit.maxPrintWidthIn} W × ${limit.maxPrintHeightIn} H in · ${limit.description}`).join('; ') : `${model?.maxPrintWidthIn} W × ${model?.maxPrintHeightIn} H in`;
   $('[data-kp-print-rates-intro]').textContent=model?.printClass?`${selected.name}: flat printing retail per selected side and per item. Planning limits: ${limits}. Actual fit and decoration require proof approval.`:`${selected.name}: printing fees and usable area are pending. Contact us for a reviewed quote.`;
   $('[data-kp-both-sides-heading]').hidden=!model?.backAllowed;
   if(!model?.printClass)return;
   const marketEntry=cartSellability.get(cartSellabilityKey());
   const purchaseModel=pilotManifest.models?.[selected.id];
   const representativeSize=selected.sizes.find(size=>purchaseModel?.variants?.[size+'|Blank']&&purchaseModel?.variants?.[size+'|Front only']);
   const variantPrice=id=>{const variant=marketEntry?.product?.variants?.find(item=>item.id===id);return variant?.available===true&&Number.isSafeInteger(variant.price)&&variant.price>0?variant.price/100:null;};
   const blank=representativeSize?variantPrice(purchaseModel.variants[representativeSize+'|Blank']):null;
   const front=representativeSize?variantPrice(purchaseModel.variants[representativeSize+'|Front only']):null;
   const baseSide=Number.isFinite(blank)&&Number.isFinite(front)?front-blank:NaN;
   const planningFees=retailPricing.printFees[model.printClass];
   if(!Number.isFinite(baseSide)||baseSide<=0||!planningFees?.[0]){$('#kp-print-rates-heading').textContent='Printing rates';$('[data-kp-print-rates-intro]').textContent=!checkoutModelIsEnabled()?'Online printing prices are not configured for this style. Contact us for a reviewed quote.':marketEntry?.status==='unavailable'||marketEntry?.status==='ready'?'Published printing prices for this selected market could not be verified. Contact us for a reviewed quote.':'Checking published printing prices for your selected market.';table.hidden=true;return;}
   const money=value=>Math.round((value+Number.EPSILON)*100)/100;
   const fees=planningFees.map(fee=>money(baseSide*fee/planningFees[0]));
   const currency=marketEntry.currency;
   const usdCartFinalOnly=currency==='USD';
   const format=value=>new Intl.NumberFormat('en-CA',{style:'currency',currency}).format(value);
   $('#kp-print-rates-heading').textContent=`Printing rates (${currency})`;
   $('[data-kp-print-rates-intro]').textContent=usdCartFinalOnly?`${selected.name}: published market base print price is shown for 1-3 items. Your discount and final price will be shown in your cart. Planning limits: ${limits}. Actual fit and decoration require proof approval.`:`${selected.name}: published market base print price with the approved print-only quantity schedule. Shopify cart confirms final rounded discounts. Planning limits: ${limits}. Actual fit and decoration require proof approval.`;
   table.hidden=false;
   retailPricing.tiers.forEach((q,i)=>{
     const row=document.createElement('tr'),last=retailPricing.tiers[i+1]?retailPricing.tiers[i+1]-1:q;
     row.dataset.tier=q;row.classList.toggle('is-current',quantity>=q&&quantity<=last);
     const heading=document.createElement('th');heading.scope='row';heading.textContent=q===last?String(q):`${q}–${last}`;row.append(heading);
     [fees[i],...(model.backAllowed?[money(fees[i]*2)]:[])].forEach(n=>{const cell=document.createElement('td');cell.textContent=usdCartFinalOnly&&i>0?'Shown in cart':format(n);row.append(cell);});body.append(row);
   });
 }

 function renderSummary() {
   const sizes = [...root.querySelectorAll('.kp-apparel__size input')].map(input => {
     const quantity = Number(input.value);
     return { size: input.dataset.size, quantity: Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 0 };
   }).filter(entry => entry.quantity);
   const total = sizes.reduce((sum, entry) => sum + entry.quantity, 0);
    const estimate = renderEstimate(total);
    const dispatchNote = $('[data-kp-dispatch-note]');
    const leadTime = $('[data-kp-lead-time]');
    const printedSides = estimate.sides?.length || 0;
    leadTime.textContent = total > 50 || total < 1 || printedSides !== 1 ? dispatchNote.dataset.kpDispatchIndividual : dispatchNote.dataset.kpDispatchSingle;
   renderCartPilot();
   const sizeText = sizes.length ? sizes.map(entry => `${entry.size} × ${entry.quantity}`).join(', ') : 'sizes not specified';
   const artText = supportedAreas().filter(area => artwork[area]).map(area => `${areas[area]}: ${artwork[area].name}${artwork[area].kind==='pdf' ? ` · PDF page ${artwork[area].pdfPage} of ${artwork[area].pdfPages}` : ''}${artwork[area].legacyUnsupported ? ' (artwork re-upload needed)' : ''} · ${sidePrefs[area].width || '?'} × ${sidePrefs[area].height || '?'} in`).join(' · ') || 'artwork not selected';
   renderPrintRates(total);
   const summaryPrice=estimate.marketPending?'Checking price':estimate.priceDisplayVerified?new Intl.NumberFormat('en-CA',{style:'currency',currency:estimate.currency}).format(estimate.total)+' '+estimate.currency+' merchandise total':estimate.presentmentCartFinalOnly?'Price shown in cart':estimate.status==='quote-only'?'Quote required':'Complete your selection to confirm the price';
   $('[data-kp-summary-line]').textContent=[selected.name,color.name,sizeText,artText,summaryPrice].join(' · ');
   root.dispatchEvent(new CustomEvent('kp:apparel-change', { detail: {
     styleId: selected.id, color: color.name, sizes, totalQuantity: total,
     artwork: Object.fromEntries(supportedAreas().map(area => [area, artwork[area] ? { name: artwork[area].name, type: artwork[area].kind, requiresArtworkReselection: Boolean(artwork[area].legacyUnsupported), requestedWidthIn: sidePrefs[area].width, requestedHeightIn: sidePrefs[area].height, pantone: sidePrefs[area].pantone, alphaBounds: artwork[area].alphaBounds, originalWidth: artwork[area].originalWidth, originalHeight: artwork[area].originalHeight, resolution: artwork[area].resolution, pdfPage: artwork[area].pdfPage, pdfPages: artwork[area].pdfPages } : null])),
     pricingStatus: estimate.status, priceEstimate: estimate, decorationReview: Boolean(selected.decorationReview), identityReview: Boolean(selected.identityReview)
   } }));
   saveDraft();
 }
 function renderSizes() {
   const host = $('[data-kp-sizes]');
   const currentSizes = renderedSizeModelId === selected.id
     ? Object.fromEntries([...host.querySelectorAll('input[data-size]')].map(input => [input.dataset.size, input.value]))
     : null;
   host.replaceChildren();
   if (!selected.sizes.length) { const note = document.createElement('p'); note.className = 'kp-apparel__help'; note.textContent = 'Size chart and size availability will be confirmed before ordering.'; host.append(note); $('[data-kp-total]').textContent = ''; return; }
   selected.sizes.forEach(size => {
     const wrap = document.createElement('div'); wrap.className = 'kp-apparel__size';
     const label = document.createElement('label'); const id = `kp-size-${size}`; label.htmlFor = id; label.textContent = size;
     const input = document.createElement('input'); input.type = 'number'; input.min = '0'; input.step = '1'; input.inputMode = 'numeric'; input.id = id; input.dataset.size = size; input.setAttribute('aria-label', `${size} quantity`); input.addEventListener('input', updateTotal);
     if (currentSizes && Object.hasOwn(currentSizes, size)) input.value = currentSizes[size];
     else if (savedDraft && (savedDraft.modelId === selected.id || migratingSelection) && savedDraft.sizes?.[size] != null) input.value = savedDraft.sizes[size];
     const price = document.createElement('span'); price.className = 'kp-apparel__size-price';
     const marketEntry=cartSellability.get(cartSellabilityKey());
     const purchaseModel=pilotManifest.models?.[selected.id];
     const blankId=purchaseModel?.variants?.[size+'|Blank'];
     const blankVariant=marketEntry?.product?.variants?.find(item=>item.id===blankId&&item.available===true&&Number.isSafeInteger(item.price)&&item.price>0);
     const garment=blankVariant?blankVariant.price/100:null;
     const currency=marketEntry?.currency||window.Shopify?.currency?.active||retailPricing.currency;
     const pending=checkoutModelIsEnabled()&&(!marketEntry||marketEntry.status==='loading');
     price.textContent = Number.isFinite(garment) ? new Intl.NumberFormat('en-CA',{style:'currency',currency}).format(garment) : pending?'Checking market price…':'Quote only';
     price.title = Number.isFinite(garment) ? 'Published garment price in your selected Shopify market; printing is additional.' : pending?'Published market garment price is being checked.':!checkoutModelIsEnabled()?'Online pricing is not configured for this style. Contact us for a reviewed quote.':'Published pricing for this size could not be verified. Contact us for a reviewed quote.';
     input.setAttribute('aria-describedby', id+'-price'); price.id = id+'-price';
     wrap.append(label, price, input); host.append(wrap);
   }); renderedSizeModelId = selected.id; updateTotal();
 }
 function updateTotal() {
   const invalid = [...root.querySelectorAll('.kp-apparel__size input')].filter(input => {
     const bad = input.value !== '' && (!/^\d+$/.test(input.value) || !Number.isSafeInteger(Number(input.value)) || Number(input.value) < 0);
     input.setAttribute('aria-invalid', String(bad)); return bad;
   });
   $('[data-kp-quantity-error]').hidden = !invalid.length;
   const total = [...root.querySelectorAll('.kp-apparel__size input')].reduce((sum, input) => {
     const value = Number(input.value); return sum + (Number.isSafeInteger(value) && value > 0 ? value : 0);
   }, 0);
   $('[data-kp-total]').textContent = `Planned quantity: ${total} ${selected.type ? "items" : "garments"}`;
   renderSummary();
 }
 function render() {
   normalizeSelection();
   areas.front = selected.type === 'hat' ? 'Front panel' : selected.type === 'bag' ? 'Front body' : 'Front';
   areas.back = selected.type === 'bag' ? 'Back body' : 'Back';
   updateMigrationNotice();
   root.querySelectorAll('[data-model]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.model === selected.id)));
   $('[data-kp-title]').textContent = selected.name;
   $('[data-kp-current-model]').textContent = selected.name;
   $('[data-kp-model]').textContent = `Style ${selected.id}${selected.note ? ' · ' + selected.note : ''}`;
   $('[data-kp-status]').textContent = selected.soldOut ? 'Availability unconfirmed' : selected.decorationReview || selected.identityReview ? 'Review required · Quote only' : 'Pricing to be confirmed';
   $('[data-kp-status]').classList.toggle('kp-apparel__badge--sold', Boolean(selected.soldOut));
   $('[data-kp-color-note]').textContent = selected.previewLimited
     ? "More colors may be available for this style. Ask us about a shade you don't see."
     : "Supplier-listed colors; availability and size/color combinations will be confirmed.";
   $('[data-kp-chosen]').textContent = `Selected color: ${color.name}`;
   $('[data-kp-notice-title]').textContent = selected.soldOut ? 'Availability unconfirmed · Contact us' : 'Ordering is not available yet.';
   $('[data-kp-notice]').textContent = selected.soldOut ? 'Contact us to discuss availability and pricing for this youth tee.' : selected.decorationReview ? 'Inquiry only: decoration method, heat compatibility and usable area must be reviewed. No sleeve, bill or mesh decoration is offered here.' : selected.identityReview ? 'Inquiry only: confirm the S05610 version, fabric weight and fit before planning production.' : 'Contact us to discuss printing, pricing, and timing for your project.';
   $('[data-kp-lead-time]').hidden = Boolean(selected.soldOut);
   renderSpecs(); renderColors(); renderSizes(); renderArtUI(); renderImage();
 }
 $('[data-kp-show-colors]').addEventListener('click', () => { colorExpanded = !colorExpanded; renderColors(); });
 $('#kp-apparel-notes').addEventListener('input', saveDraft);
 ['width', 'height'].forEach(dimension => {
   const input = $(`[data-kp-print-${dimension}]`);
   input.addEventListener('input', event => setRequestedDimension(dimension, event.target));
   input.addEventListener('blur', () => { if (input.getAttribute('aria-invalid') !== 'true') { if (sidePrefs[view][dimension]) sidePrefs[view][dimension] = String(Number(sidePrefs[view][dimension])); syncDimensionUI(); renderSummary(); } });
 });
 $('[data-kp-pantone]').addEventListener('input', event => { sidePrefs[view].pantone = event.target.value.trim(); renderSummary(); });

 let cartBusy=false,activeCartJob=editJob||(/^[0-9a-f-]{36}$/i.test(savedDraft?.cartJob||'')?savedDraft.cartJob:''),committedModel=savedDraft?.cartJob?selected.id:'',cartCommitted=savedDraft?.cartCommitted===true;
 function currentCartPlan() {
   const sizes = [...root.querySelectorAll('.kp-apparel__size input')].map(el => ({size:el.dataset.size,quantity:Number(el.value || 0)}));
   return buildApparelCartPlan({modelId:selected.id,estimate:currentEstimate,sizes,color:color.name,artwork,sidePrefs,notes:$('#kp-apparel-notes').value},pilotManifest,retailPricing);
 }
 const cartSellability = new Map();
 let cartError = '';
 function cartSellabilityKey() {
   return selected.id + '|' + window.location.origin + '|' + (window.Shopify?.routes?.root || '/') + '|' + (window.Shopify?.currency?.active || '');
 }
 function checkoutModelIsEnabled(modelId=selected.id) {
   return Boolean(pilotManifest.enabled&&pilotManifest.models?.[modelId]&&(!pilotManifest.enabledModels||pilotManifest.enabledModels.includes(modelId)));
 }
 function loadCartSellability(model, key) {
   const entry = {status:'loading', checkedAt:Date.now(), product:null, currency:null};
   cartSellability.set(key, entry);
   const route = window.Shopify?.routes?.root || '/';
   const controller=new AbortController();
   const timeout=setTimeout(()=>controller.abort(),15000);
   const read = async endpoint => {
     const response = await fetch(route + endpoint, {headers:{Accept:'application/json'}, cache:'no-store',signal:controller.signal});
     if (!response.ok) throw new Error('This style currently needs an inquiry.');
     return response.json();
   };
   (async()=>{
     try {
       const cart = await read('cart.js');
       if (!pilotManifest.presentmentCurrencies.includes(cart.currency)) throw new Error('This currency needs a reviewed apparel quote.');
       entry.currency = cart.currency;
       const product = await read('products/' + encodeURIComponent(model.handle) + '.js');
       if (!apparelProductIsSellable(product, model)) throw new Error('This style currently needs an inquiry.');
       entry.product = product;
       entry.status = 'ready';
     } catch (_) {
       entry.status = 'unavailable';
     } finally {
       clearTimeout(timeout);
     }
     entry.checkedAt = Date.now();
     if (cartSellability.get(key) === entry && cartSellabilityKey() === key) renderSizes();
   })();
   return entry;
 }
 function renderCartPilot() {
   const host=$('[data-kp-cart-pilot]'),button=$('[data-kp-add-apparel-cart]'),note=$('[data-kp-cart-pilot-note]');
   host.hidden=false;
   root.dataset.purchaseReady='false';
   button.disabled=true;
   if(committedModel&&committedModel!==selected.id){activeCartJob='';committedModel='';cartCommitted=false;}
   if(cartCommitted){button.textContent='Saved to cart';note.textContent='Your selected sizes are saved in your cart. Change this design to update the saved item, or choose Start over for another design.';note.append(' ',root.querySelector('[data-kp-full-cart-template]').content.cloneNode(true));return;}
   button.textContent=cartBusy?'Saving artwork and selected sizes.':activeCartJob?'Update cart design':'Add selected sizes to cart';
   $('[data-kp-artwork-handoff-note]').textContent='Original artwork stays on your device and must be emailed separately when requesting a quote.';
   const model=pilotManifest.models?.[selected.id];
   if(editJob&&!cartEditReady){button.disabled=true;note.textContent=cartRestoreError||'Restoring the selected cart design.';return;}
   if (!model || !pilotManifest.enabled || (pilotManifest.enabledModels && !pilotManifest.enabledModels.includes(selected.id))) {
     note.textContent='This style is not ready for online checkout yet. Use Contact us to confirm availability and pricing.';
     return;
   }
   if (cartBusy) {host.hidden=false;button.textContent='Saving artwork and selected sizes…';return;}
   const key=cartSellabilityKey();
   let entry=cartSellability.get(key);
   if (!entry || Date.now()-entry.checkedAt>30000) entry=loadCartSellability(model,key);
   if (entry.status==='loading') {
     $('[data-kp-notice-title]').textContent='Checking availability';
     $('[data-kp-notice]').textContent='Checking this style in your selected currency. Your artwork remains on your device.';
     note.textContent='Checking this style. If you click now, no cart request will be sent until the check passes.';
     return;
   }
   if (entry.status!=='ready') {
     $('[data-kp-notice-title]').textContent='Quote required';
     $('[data-kp-notice]').textContent=cartError || 'This style is not currently available to add to your cart. Contact us to confirm availability and your order.';
     note.textContent=cartError || 'This style is not ready for online checkout. Click for details or use Contact us.';
     return;
   }
   host.hidden=false;
   root.dataset.purchaseReady='true';
   $('[data-kp-status]').textContent='Available to order';
   $('[data-kp-color-note]').textContent='Choose a supplier colour. Final artwork and print placement are reviewed before production.';
   $('[data-kp-summary-heading]')?.setAttribute('data-ready','true');
   button.textContent=activeCartJob?'Update cart design':'Add selected sizes to cart';
   $('[data-kp-notice-title]').textContent='Review your artwork and size mix';
   $('[data-kp-notice]').textContent='Choose quantities. Add artwork for printing, or leave it empty for blanks. We review artwork before production.';
   $('[data-kp-artwork-handoff-note]').textContent='Your original artwork files and selected print details will be saved with every size when you add to cart.';
   try {
     const plan=currentCartPlan();
     if (!apparelProductIsSellable(entry.product,model,plan.lines)) throw new Error('A selected size or print configuration needs a reviewed quote.');
     button.disabled=false;
     const usdCartFinalOnly=entry.currency==='USD'&&currentEstimate.sides?.length>0&&currentEstimate.tier>1;
     note.textContent=cartError || (usdCartFinalOnly?'Price shown in cart. Artwork and print details are saved with every size. Tax and shipping extra.':'Artwork and print details are saved with every size. Tax and shipping extra.');
   } catch(error) {
     note.textContent=error.message;
   }
 }
 function refreshCartSellability() {
   if (cartBusy) return;
   cartSellability.clear();
   renderCartPilot();
 }
 window.addEventListener('focus',refreshCartSellability);
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')refreshCartSellability();});
 setInterval(()=>{if(document.visibilityState==='visible')refreshCartSellability();},30000);
 $('[data-kp-add-apparel-cart]').addEventListener('click',async()=>{
   if(cartBusy||!cartEditReady||cartCommitted)return;
   let plan;
   cartError='';
   const note=$('[data-kp-cart-pilot-note]');
   const model=pilotManifest.models?.[selected.id];
   if(!model||!pilotManifest.enabled||(pilotManifest.enabledModels&&!pilotManifest.enabledModels.includes(selected.id))){note.textContent='This style is not ready for online checkout yet. No cart request was sent. Use Contact us to confirm availability and pricing.';return;}
   const entry=cartSellability.get(cartSellabilityKey());
   if(!entry||entry.status==='loading'){note.textContent='Availability is still being checked. No cart request was sent; try again in a moment.';return;}
   if(entry.status!=='ready'){note.textContent=cartError||'This style is not ready for online checkout. No cart request was sent. Use Contact us to confirm availability and pricing.';return;}
   try {plan=currentCartPlan();if(!apparelProductIsSellable(entry.product,model,plan.lines))throw new Error('A selected size or print configuration needs a reviewed quote.');}catch(error){note.textContent=error.message+' No cart request was sent.';return;}
   cartBusy=true;renderCartPilot();
   try {
     const result=await addApparelCartPlan(plan,{replaceJob:activeCartJob});
     activeCartJob=result.job;committedModel=selected.id;cartCommitted=true;cartBusy=false;
     session.committed();saveDraft();
     renderCartPilot();
     try{const {CartUpdateEvent}=await import('@theme/events');document.dispatchEvent(new CartUpdateEvent(result.cart,'kippush-apparel',{source:'kippush-apparel',itemCount:result.cart.item_count}));document.querySelector('cart-drawer-component')?.open();}catch{note.prepend('Saved successfully. Open the full cart to review your items. ');}
   } catch(error) {
     cartBusy=false;
     cartError=error.message;
     cartSellability.clear();
     renderCartPilot();
   }
 });

 $('[data-kp-contact]').addEventListener('click', event => {
   const invalid = root.querySelector('.kp-apparel__size input[aria-invalid="true"]');
   if (invalid) { event.preventDefault(); invalid.focus(); return; }
   const invalidDimension = root.querySelector('[data-kp-print-width][aria-invalid="true"],[data-kp-print-height][aria-invalid="true"]');
   if (invalidDimension) { event.preventDefault(); invalidDimension.focus(); return; }
   if (!saveDraft()) { event.preventDefault(); return; }
 });
 root.querySelectorAll('[data-kp-view]').forEach(button => button.addEventListener('click', () => {
   view = button.dataset.kpView; if (selected.type === 'hat') hatProductView = 'front'; renderArtUI(); renderImage();
 }));
 $('[data-kp-side-thumb]').addEventListener('click', () => {
   view = view === 'front' ? 'back' : 'front'; renderArtUI(); renderImage();
 });
 async function handleArtworkFile(file) {
   if (!file) return;
   const ext = file.name.toLowerCase().match(/\.([a-z0-9]+)$/)?.[1];
   const mime = file.type.toLowerCase();
   const kind = ext === 'png' ? 'png' : ['jpg','jpeg'].includes(ext) ? 'jpeg' : ext === 'pdf' ? 'pdf' : '';
   const mimeMatches = !mime || mime === 'application/octet-stream' || (kind === 'png' && mime === 'image/png') || (kind === 'jpeg' && mime === 'image/jpeg') || (kind === 'pdf' && mime === 'application/pdf');
   if (!kind || !mimeMatches) {
     $('[data-kp-file-note]').textContent = 'Supported artwork formats: PNG, JPG, JPEG and PDF. Your previous artwork is still selected.'; return;
   }
   if (file.size > 10 * 1024 * 1024) {
     $('[data-kp-file-note]').textContent = 'Artwork must be 10 MB or smaller. Your previous artwork is still selected.'; return;
   }
   if (!file.size) { $('[data-kp-file-note]').textContent = 'This artwork file is empty. Your previous artwork is still selected.'; return; }
   const area = view, request = ++fileRequest;
   try {
     const head = new Uint8Array(await file.slice(0, 8).arrayBuffer());
     const tail = kind === 'jpeg' ? new Uint8Array(await file.slice(-2).arrayBuffer()) : null;
     if (request !== fileRequest) return;
     const validPng = kind === 'png' && head.length === 8 && [137,80,78,71,13,10,26,10].every((byte, index) => head[index] === byte);
     const validJpeg = kind === 'jpeg' && head.length >= 3 && head[0] === 255 && head[1] === 216 && head[2] === 255 && tail?.length === 2 && tail[0] === 255 && tail[1] === 217;
     const validPdf = kind === 'pdf' && head.length >= 5 && head[0] === 37 && head[1] === 80 && head[2] === 68 && head[3] === 70 && head[4] === 45;
     if (!validPng && !validJpeg && !validPdf) {
       $('[data-kp-file-note]').textContent = 'This file does not contain valid PNG, JPEG or PDF artwork. Your previous artwork is still selected.'; return;
     }
   } catch (_) { $('[data-kp-file-note]').textContent = 'This artwork file could not be read. Your previous artwork is still selected.'; return; }
   try {
     const analysis=kind === 'png' ? await analyzePngArtwork(file) : kind === 'jpeg' ? await analyzeJpegArtwork(file) : await analyzePdfArtworkFile(file,1);
     if(request!==fileRequest){URL.revokeObjectURL(analysis.url);return;}
     const fitted=fitArtworkDimensions(analysis.pixelWidth/analysis.resolution.ppi,analysis.pixelHeight/analysis.resolution.ppi,apparelPrintLimit(retailPricing.models[selected.id],area));
     clearArtwork(area,true);
     artwork[area]={name:file.name,file,kind,...analysis,x:defaultArtworkX(area),y:defaultArtworkY(area),scale:100,maxFitAdjusted:fitted.adjusted};
     sidePrefs[area].width=String(fitted.width);sidePrefs[area].height=String(fitted.height);
     if(selected.type==='hat')hatProductView='front';
     persistArtwork(area);renderArtUI();renderImage();
   } catch(error) {if(request===fileRequest)$('[data-kp-file-note]').textContent=error.message+' Your previous artwork is kept.';}
 }
 const uploadZone = $('[data-kp-upload]');
 $('[data-kp-file]').addEventListener('change', event => {
   const file = event.target.files[0]; event.target.value = '';
   handleArtworkFile(file);
 });
 uploadZone.addEventListener('dragover', event => {
   if (Array.from(event.dataTransfer?.types || []).includes('Files')) { event.preventDefault(); uploadZone.classList.add('is-dragover'); }
 });
 uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('is-dragover'));
 uploadZone.addEventListener('drop', event => {
   event.preventDefault(); uploadZone.classList.remove('is-dragover');
   handleArtworkFile(event.dataTransfer?.files?.[0]);
 });
 $('[data-kp-pdf-page]').addEventListener('change',async event=>{
   const area=view,art=artwork[area],pageNumber=Number(event.target.value);
   if(art?.kind!=='pdf'||!art.file||!Number.isSafeInteger(pageNumber)||pageNumber<1||pageNumber>art.pdfPages)return;
   const request=++fileRequest;
   try{
     const analysis=await analyzePdfArtworkFile(art.file,pageNumber);
     if(request!==fileRequest){URL.revokeObjectURL(analysis.url);return;}
     const limit=apparelPrintLimit(retailPricing.models[selected.id],area);
     const currentWidth=Number(sidePrefs[area].width)||analysis.pixelWidth/analysis.resolution.ppi;
     const fitted=fitArtworkDimensions(currentWidth,currentWidth/analysis.ratio,limit);
     if(art.url)URL.revokeObjectURL(art.url);
     Object.assign(art,analysis,{maxFitAdjusted:Boolean(art.maxFitAdjusted||fitted.adjusted)});
     sidePrefs[area].width=String(fitted.width);sidePrefs[area].height=String(fitted.height);
     persistArtwork(area);renderArtUI();renderImage();
   }catch(error){if(request===fileRequest)$('[data-kp-file-note]').textContent=error.message+' Your previous PDF page is still selected.';}
 });
 $('[data-kp-art-center]').addEventListener('click', () => {
   const art = artwork[view]; if (!art?.url) return;
   const { box, region } = artworkLayout(art);
   art.x = defaultArtworkX(view);
   art.y = ((region.top + region.bottom) / 2 - box.top) / box.height * 100;
   updateOverlay();
 });
 $('[data-kp-art-reset]').addEventListener('click', () => {
   if (!artwork[view]?.url) return;
   Object.assign(artwork[view], { x: defaultArtworkX(view), y: defaultArtworkY(), scale: 100 });
   renderArtUI(); updateOverlay(true);
 });
 $('[data-kp-art-remove]').addEventListener('click', () => { clearArtwork(view); renderArtUI(); renderImage(); });
 $('[data-kp-reset-all]').addEventListener('click', () => { fileRequest++; clearArtwork(); renderArtUI(); renderImage(); });
 window.addEventListener('resize', () => { updateOverlay(false); renderThumbnail(); });
 window.addEventListener('pageshow', event => {
   if (!event.persisted) return;
   cartBusy = false;
   cartError = '';
   cartSellability.clear();
   normalizeSelection();
   $('[data-kp-chosen]').textContent = `Selected color: ${color.name}`;
   renderSpecs(); renderColors(); renderArtUI(); renderImage(); renderSummary();
 });
 const session=createSession(root,{editJob,startOver:async()=>{
   if(cartBusy||restoring)return false;
   fileRequest++;clearArtwork();savedDraft=null;migrationNotice='';storageWarning='';activeCartJob='';committedModel='';cartCommitted=false;
   color=colorsFor(selected)[0];view='front';$('#kp-apparel-notes').value='';
   root.querySelectorAll('.kp-apparel__size input').forEach(input=>input.value='');
   try{sessionStorage.removeItem(draftKey);}catch{}
   await Promise.all(Object.keys(areas).map(area=>fileStore('delete',area).catch(()=>{})));
   render();saveDraft();return true;
 }});
 const resumeCommittedEdit=()=>{if(cartCommitted){cartCommitted=false;renderCartPilot();}};
 root.addEventListener('input',resumeCommittedEdit,true);
 root.addEventListener('change',resumeCommittedEdit,true);
 root.addEventListener('click',event=>{if(event.target.closest('[data-kp-art-remove],[data-kp-art-reset],[data-kp-art-center]'))resumeCommittedEdit();},true);
 root.addEventListener('pointerup',event=>{if(event.isTrusted&&event.target.closest('[data-kp-image]'))resumeCommittedEdit();});
 render();
 if (savedDraft) {
   root.querySelector('.kp-apparel__content').inert=true;
   $('#kp-apparel-notes').value = savedDraft.notes || '';
   Promise.all(Object.keys(areas).map(async area => {
     const info = savedDraft.artwork?.[area]; if (!info) return;
     try {
       const record = restoredCartFiles[area]?{file:restoredCartFiles[area],savedAt:Date.now()}:await fileStore('get', area);
       if (!record?.file || Date.now() - record.savedAt > draftLifetime || record.file.name !== info.name) {
         storageWarning = `Saved ${area} artwork (${info.name}) could not be restored from this device. Select the original file again.`;
         return;
       }
       const file=record.file;
       const isPng=info.kind==='png'&&/\.png$/i.test(file.name);
       const isJpeg=info.kind==='jpeg'&&/\.jpe?g$/i.test(file.name);
       const isPdf=info.kind==='pdf'&&/\.pdf$/i.test(file.name);
       const analysis=isPng?await analyzePngArtwork(file):isJpeg?await analyzeJpegArtwork(file):isPdf?await analyzePdfArtworkFile(file,info.pdfPage||1):{url:null};
       artwork[area]={...info,...analysis,file,legacyUnsupported:!isPng&&!isJpeg&&!isPdf};
       if(isPng||isJpeg||isPdf){
         const pref=sidePrefs[area],limit=apparelPrintLimit(retailPricing.models[selected.id],area);
         const width=Number(pref.width)||analysis.pixelWidth/analysis.resolution.ppi;
         const fitted=fitArtworkDimensions(width,width/analysis.ratio,limit);
         if(fitted){pref.width=String(fitted.width);pref.height=String(fitted.height);artwork[area].maxFitAdjusted=Boolean(info.maxFitAdjusted||fitted.adjusted);}
       }
     } catch (_) { storageWarning = 'Artwork could not be restored from this device. Please select the original file again.'; }
   })).then(() => {
     restoring = false;root.querySelector('.kp-apparel__content').inert=false;
     if(editJob){cartEditReady=!storageWarning&&!cartRestoreError;root.querySelector('.kp-apparel__content').inert=false;if(!cartEditReady)cartRestoreError=cartRestoreError||storageWarning;}
     renderArtUI(); renderImage(); updateTotal();session.restored();if(cartRestoreError)$('[data-kp-draft-status]').textContent=cartRestoreError;
   });
 } else { restoring = false; root.querySelector('.kp-apparel__content').inert=false;saveDraft();if(cartRestoreError)$('[data-kp-draft-status]').textContent=cartRestoreError; }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-contact-page"] && !Shopify.designMode) return;
  try {
    
  const initKippushContactForms = (root = document) => {
    root.querySelectorAll('[data-kp-contact-form]').forEach((form) => {
      if (form.dataset.kpReady === 'true') return;
      form.dataset.kpReady = 'true';

      const update = () => {
        const selected = form.querySelector('input[name="contact[inquiry_type]"]:checked');
        const value = selected ? selected.value : '';
        form.querySelectorAll('[data-kp-show-for]').forEach((group) => {
          const visible = group.dataset.kpShowFor === value;
          group.hidden = !visible;
          group.querySelectorAll('[data-kp-conditional-field]').forEach((field) => {
            field.disabled = !visible;
          });
        });
        const section = form.closest('.kp-contact-page');
        section.querySelector('[data-kp-production-label]').textContent = value === 'Custom apparel' ? 'We source and make it' : 'We make it';
        section.querySelector('[data-kp-production-time]').textContent = value === 'Custom apparel'
          ? 'Production timing is confirmed with you. Shipping time is additional.'
          : 'Production timing is confirmed with you after the proof is approved. Shipping time is additional.';
      };

      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="contact[inquiry_type]"]')) update();
      });
      if (new URLSearchParams(window.location.search).get('topic') === 'custom-apparel') {
        const apparel = form.querySelector('input[name="contact[inquiry_type]"][value="Custom apparel"]');
        if (apparel) apparel.checked = true;
        try {
          const draft = JSON.parse(sessionStorage.getItem('kp-apparel-inquiry-v2') || 'null');
          if (draft?.version === 2 && Date.now() - draft.savedAt < 24 * 60 * 60 * 1000) {
            const sizes = Object.entries(draft.sizes || {}).filter(([, quantity]) => /^\d+$/.test(quantity) && Number(quantity) > 0);
            const total = sizes.reduce((sum, [, quantity]) => sum + Number(quantity), 0);
            const sizeText = sizes.length ? sizes.map(([size, quantity]) => `${size} × ${quantity}`).join(', ') : 'Not specified';
            const artText = ['front', 'back'].filter(area => draft.artwork?.[area] || Object.values(draft.sidePrefs?.[area] || {}).some(Boolean)).map(area => {
              const art = draft.artwork?.[area], pref = draft.sidePrefs?.[area] || {};
              const requestedSize = pref.width || pref.height ? `requested print size ${pref.width || '?'} × ${pref.height || '?'} inches` : 'print size to be confirmed';
              const pantone = pref.pantone ? `Pantone Solid Coated references: ${pref.pantone}` : 'no Pantone reference';
              const trim = art?.alphaBounds ? `visible PNG pixels ${art.alphaBounds.left}, ${art.alphaBounds.top}, ${art.alphaBounds.width} × ${art.alphaBounds.height} on original ${art.originalWidth} × ${art.originalHeight} canvas; ${art.resolution?.label || 'physical size needs confirmation'}; original PNG retained` : 'visible pixel bounds need review';
              const preview = art?.kind === 'png'
                ? `approximate preview placement ${Math.round(art.x)}% across, ${Math.round(art.y)}% down; relative preview scale ${Math.round(art.scale)}%`
                : 'saved previous file for reference; PNG re-upload needed before emailing artwork';
              return `${area === 'front' ? 'Front' : 'Back'}: ${art?.name || 'no artwork file selected'} (${requestedSize}; ${pantone}; ${art ? preview + '; ' + trim + '; ' : ''}final print dimensions and placement to be confirmed)`;
            }).join('; ') || 'No artwork selected';
            const estimate = draft.estimate;
            const approvedLimits={"5000":{"width":12.0,"height":16.0,"back":true},"WERK250":{"width":12.0,"height":16.0,"back":true},"HERO300":{"width":12.0,"height":16.0,"back":true},"Q126300":{"width":12.0,"height":16.0,"back":true},"QTB":{"width":12.0,"height":16.0,"back":true},"QTBG":{"width":12.0,"height":16.0,"back":true},"VC700":{"width":4.5,"height":2.5,"back":false},"6506":{"width":4.5,"height":2.5,"back":false},"8869":{"width":4.5,"height":2.5,"back":false},"S05610":{"width":12.0,"height":16.0,"back":true}};
            const limit=approvedLimits[draft.modelId];
            const requestedAreas=Object.keys(draft.artwork || {}).filter(area=>draft.artwork[area]);
            const withinLimits=Boolean(limit)&&requestedAreas.length>0&&requestedAreas.every(area=>{const pref=draft.sidePrefs?.[area],width=Number(pref?.width),height=Number(pref?.height);return ['front','back'].includes(area)&&(area!=='back'||limit.back)&&Number.isFinite(width)&&Number.isFinite(height)&&width>0&&height>0&&width<=limit.width&&height<=limit.height;});
            const staleHatEstimate = ['VC700','6506','8869'].includes(draft.modelId) && estimate?.printFeeRevision !== 'cap-fees-2026-10-12-v1';
            const hasEstimate = !staleHatEstimate && withinLimits && estimate?.version === '2026-10-12-v5' && estimate?.currency === 'CAD' && estimate.quantity === total && Number.isFinite(estimate.total) && (Number.isFinite(estimate.perItem) || estimate.sizeLines?.length) && estimate.sides?.length;
            const estimateText = hasEstimate
              ? `Draft CAD estimate: ${Number.isFinite(estimate.perItem) ? estimate.perItem.toFixed(2) + ' / item' : estimate.sizeLines.map(x => x.size + ': ' + x.perItem.toFixed(2) + ' / item × ' + x.quantity).join('; ')} · ${estimate.total.toFixed(2)} total for ${total} items. Final quote required; shipping and applicable tax are additional. This estimate does not set checkout charges.${estimate.status === 'review-required' ? ' Review and approval required.' : ''}`
              : staleHatEstimate ? 'Hat printing prices have been updated. Return to the apparel draft to refresh your estimate before sending the inquiry.' : !withinLimits && limit ? `Quote only: artwork must fit ${limit.width} in wide × ${limit.height} in high on each approved side. Correct or confirm the request with Kippush; no price has been accepted.` : 'Quote only: final pricing, shipping and applicable tax require confirmation.';
            const model = form.querySelector('input[name="contact[apparel_model]"]');
            const quantity = form.querySelector('input[name="contact[apparel_quantity]"]');
            model.value = draft.model || draft.modelId || '';
            if (total > 0) quantity.value = String(total);
            const body = form.querySelector('textarea[name="contact[body]"]');
            const lines = [
              'Custom apparel inquiry', `Style: ${draft.model || draft.modelId}`, `Color: ${draft.color}`,
              `Quantities by size: ${sizeText}`, `Total planned: ${total}`, `Artwork: ${artText}`, estimateText,
              draft.notes?.trim() ? `Design or order notes: ${draft.notes.trim()}` : null,
              draft.artwork?.front || draft.artwork?.back ? 'Original PNG artwork is on my device and will be sent separately by email. Any older non-PNG file listed above is for reference and needs a PNG replacement.' : 'I can email PNG artwork separately if needed.'
            ].filter(Boolean);
            if (!body.value.trim()) body.value = lines.join('\n');
            const handoff = form.querySelector('[data-kp-apparel-handoff]');
            handoff.hidden = false;
            handoff.querySelector('[data-kp-apparel-handoff-summary]').textContent = `${draft.model || draft.modelId} · ${draft.color} · ${sizeText} · ${artText} · ${estimateText}`;
          }
        } catch (_) { /* A blocked or expired browser session leaves the normal contact form available. */ }
      }
      update();
    });
  };

  initKippushContactForms();
  document.addEventListener('shopify:section:load', (event) => initKippushContactForms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-services-hub"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kp-services]').forEach((section) => {
  if (section.dataset.kpServicesReady === 'true') return;
  section.dataset.kpServicesReady = 'true';

  const demo = section.querySelector('[data-kp-demo]');
  if (!demo) return;

  const input = demo.querySelector('[data-demo-input]');
  const previewImage = demo.querySelector('[data-demo-image]');
  const emptyState = demo.querySelector('[data-demo-empty]');
  const filename = demo.querySelector('[data-demo-filename]');
  const removeButton = demo.querySelector('[data-demo-remove]');
  const error = demo.querySelector('[data-demo-error]');
  const labels = {
    none: filename.textContent,
    invalid: demo.dataset.invalid,
    tooLarge: demo.dataset.tooLarge
  };
  let objectUrl = '';

  const clearPreview = (announce = true) => {
    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = '';
    input.value = '';
    previewImage.removeAttribute('src');
    previewImage.hidden = true;
    emptyState.hidden = false;
    demo.classList.remove('has-image');
    removeButton.hidden = true;
    error.hidden = true;
    if (announce) filename.textContent = labels.none;
  };

  input.addEventListener('change', () => {
    const file = input.files && input.files[0];
    if (!file) {
      clearPreview();
      return;
    }

    const validType = file.type === 'image/png' || file.type === 'image/jpeg';
    if (!validType) {
      clearPreview(false);
      filename.textContent = labels.none;
      error.textContent = labels.invalid;
      error.hidden = false;
      return;
    }

    if (file.size > 10485760) {
      clearPreview(false);
      filename.textContent = labels.none;
      error.textContent = labels.tooLarge;
      error.hidden = false;
      return;
    }

    if (objectUrl) URL.revokeObjectURL(objectUrl);
    objectUrl = URL.createObjectURL(file);
    previewImage.src = objectUrl;
    previewImage.hidden = false;
    emptyState.hidden = true;
    demo.classList.add('has-image');
    filename.textContent = file.name;
    removeButton.hidden = false;
    error.hidden = true;
  });

  removeButton.addEventListener('click', () => {
    clearPreview();
    input.focus();
  });

  window.addEventListener('pagehide', () => {
    if (objectUrl) URL.revokeObjectURL(objectUrl);
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('kp-holiday-filter')) {
    customElements.define(
      'kp-holiday-filter',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.resultsList = this.closest('results-list');
          this.grid = this.resultsList?.querySelector('#ResultsList [ref="grid"], #ResultsList ul.product-grid');
          this.buttons = [...this.querySelectorAll('[data-holiday-key]')];
          this.keys = this.buttons.map((button) => button.dataset.holidayKey);
          this.onPopState = () => this.apply(this.keyFromUrl(), false);
          window.addEventListener('popstate', this.onPopState);

          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-holiday-key]');
            if (!button) return;
            this.apply(button.dataset.holidayKey, true);
          });

          if (!this.grid) return;
          this.setAttribute('aria-busy', 'true');
          this.loadEveryPage()
            .catch(() => undefined)
            .finally(() => {
              this.updateCounts();
              this.apply(this.keyFromUrl(), false);
              this.hidePagination();
              this.setAttribute('aria-busy', 'false');
            });
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.onPopState);
        }

        keyFromUrl() {
          const key = new URL(window.location.href).searchParams.get('holiday') || 'all';
          return this.keys.includes(key) ? key : 'all';
        }

        async loadEveryPage() {
          const total = Number(this.dataset.total) || 0;
          const pageSize = Number(this.dataset.pageSize) || 24;
          const pageCount = Math.ceil(total / pageSize);
          if (pageCount < 2) return;

          const currentPage = Number(this.grid.querySelector(':scope > li[data-page]')?.dataset.page) || 1;
          const seen = new Set(
            [...this.grid.querySelectorAll(':scope > li[data-product-id]')].map((card) => card.dataset.productId)
          );

          for (let page = 1; page <= pageCount; page += 1) {
            if (page === currentPage) continue;
            const requestUrl = new URL(window.location.href);
            requestUrl.searchParams.delete('holiday');
            requestUrl.searchParams.set('page', String(page));
            requestUrl.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(requestUrl, { headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Holiday collection page could not be loaded.');
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const cards = [...parsed.querySelectorAll('li[data-product-id]')];
            for (const card of cards) {
              if (seen.has(card.dataset.productId)) continue;
              seen.add(card.dataset.productId);
              this.grid.append(document.importNode(card, true));
            }
          }
        }

        updateCounts() {
          const cards = [...this.grid.querySelectorAll(':scope > li[data-product-id]')];
          for (const button of this.buttons) {
            const key = button.dataset.holidayKey;
            const count = key === 'all' ? cards.length : cards.filter((card) => card.dataset.holiday === key).length;
            const output = button.querySelector('[data-holiday-count]');
            if (output) output.textContent = String(count);
          }
        }

        apply(requestedKey, updateUrl) {
          if (!this.grid) return;
          const key = this.keys.includes(requestedKey) ? requestedKey : 'all';
          const cards = [...this.grid.querySelectorAll(':scope > li[data-product-id]')];
          let visible = 0;

          for (const card of cards) {
            const show = key === 'all' || card.dataset.holiday === key;
            card.hidden = !show;
            if (show) visible += 1;
          }

          for (const button of this.buttons) {
            const selected = button.dataset.holidayKey === key;
            button.setAttribute('aria-pressed', String(selected));
          }

          const count = this.querySelector('[data-holiday-visible-count]');
          if (count) count.textContent = String(visible);
          const empty = this.querySelector('[data-holiday-empty]');
          if (empty) empty.hidden = visible !== 0;

          if (updateUrl) {
            const nextUrl = new URL(window.location.href);
            if (key === 'all') nextUrl.searchParams.delete('holiday');
            else nextUrl.searchParams.set('holiday', key);
            nextUrl.searchParams.delete('page');
            window.history.pushState({}, '', nextUrl);
          }
        }

        hidePagination() {
          this.resultsList
            ?.querySelectorAll('.pagination, pagination-component, [ref="pagination"]')
            .forEach((element) => element.setAttribute('hidden', ''));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
